// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Person/WizardAddPerson.css */
/* Full-page multi-step wizard */

/* ===================== FULL PAGE LAYOUT ===================== */

.wizard-add-person-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: white;
  overflow: hidden;
}

/* Topbar - Title left, Steps center, Save/Close right */
.wizard-add-person-page .wizard-topbar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  padding: 12px 24px;
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  color: white;
  flex-shrink: 0;
  gap: 20px;
}

.wizard-add-person-page .topbar-left {
  display: flex;
  align-items: center;
}

.wizard-add-person-page .topbar-left h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
}

/* Step indicators - CENTERED in middle column */
.wizard-add-person-page .steps-indicator {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 0;
  background: none;
  border: none;
}

.wizard-add-person-page .step-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 24px;
  background: rgba(255,255,255,0.2);
  border: 2px solid rgba(255,255,255,0.3);
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person-page .step-indicator:hover {
  background: rgba(255,255,255,0.3);
}

.wizard-add-person-page .step-indicator.active {
  background: white;
  border-color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.wizard-add-person-page .step-indicator.active .step-number {
  background: #FF6F61;
  color: white;
}

.wizard-add-person-page .step-indicator.active .step-label {
  color: #FF6F61;
  font-weight: 600;
}

.wizard-add-person-page .step-indicator.completed {
  background: #10B981;
  border-color: #10B981;
}

.wizard-add-person-page .step-indicator .step-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

.wizard-add-person-page .step-indicator.completed .step-number {
  background: rgba(255,255,255,0.3);
}

.wizard-add-person-page .step-indicator .step-label {
  font-size: 14px;
  font-weight: 500;
  color: white;
}

.wizard-add-person-page .topbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wizard-add-person-page .save-draft-btn {
  padding: 8px 20px;
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.4);
  color: white;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 110px;
}

.wizard-add-person-page .save-draft-btn:hover:not(:disabled) {
  background: rgba(255,255,255,0.35);
  transform: translateY(-1px);
}

.wizard-add-person-page .save-draft-btn:disabled {
  cursor: wait;
  opacity: 0.7;
}

/* Saving state - subtle pulse animation */
.wizard-add-person-page .save-draft-btn.saving {
  background: rgba(255,255,255,0.15);
  animation: wizardSavingPulse 1s ease-in-out infinite;
}

@keyframes wizardSavingPulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

/* Success state - brief green flash */
.wizard-add-person-page .save-draft-btn.success {
  background: rgba(16, 185, 129, 0.7);
  border-color: rgba(16, 185, 129, 0.9);
  animation: wizardSuccessFlash 0.4s ease-out;
}

@keyframes wizardSuccessFlash {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.6); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px 4px rgba(16, 185, 129, 0.4); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
}

.wizard-add-person-page .topbar-right .close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.wizard-add-person-page .topbar-right .close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===================== COMPACT PERSON INFO BAR ===================== */

.wizard-add-person-page .person-info-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
  margin: 20px 0;
}

.wizard-add-person-page .info-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-person-page .info-separator {
  width: 1px;
  height: 32px;
  background: #E2E8F0;
}

/* Identity inputs */
.wizard-add-person-page .identity-group .name-input {
  padding: 10px 14px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  width: 160px;
  transition: border-color 0.2s;
}

.wizard-add-person-page .identity-group .name-input:focus {
  outline: none;
  border-color: #FF6F61;
}

/* Status chips */
.wizard-add-person-page .status-group .status-chip {
  width: 40px;
  height: 40px;
  border: 2px solid #E2E8F0;
  border-radius: 10px;
  background: white;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wizard-add-person-page .status-group .status-chip:hover {
  border-color: #FF6F61;
  background: #FFF5F4;
}

.wizard-add-person-page .status-group .status-chip.selected {
  border-color: #FF6F61;
  background: #FF6F61;
}

/* Children control */
.wizard-add-person-page .children-group .children-label {
  font-size: 13px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-person-page .children-group .child-btn {
  width: 32px;
  height: 32px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: white;
  font-size: 18px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-person-page .children-group .child-btn:hover:not(:disabled) {
  border-color: #FF6F61;
  color: #FF6F61;
}

.wizard-add-person-page .children-group .child-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.wizard-add-person-page .children-group .child-count {
  font-size: 18px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

/* Single parent checkbox */
.wizard-add-person-page .single-parent-check {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #64748B;
  cursor: pointer;
}

.wizard-add-person-page .single-parent-check input {
  width: 16px;
  height: 16px;
  accent-color: #FF6F61;
}

/* Fiscal badge */
.wizard-add-person-page .fiscal-badge {
  display: flex;
  align-items: baseline;
  gap: 4px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  border-radius: 24px;
  color: white;
}

.wizard-add-person-page .fiscal-badge .fiscal-value {
  font-size: 20px;
  font-weight: 700;
}

.wizard-add-person-page .fiscal-badge .fiscal-unit {
  font-size: 12px;
  font-weight: 500;
  opacity: 0.9;
}

/* Legacy modal support - kept for compatibility */
.modal-content.wizard-add-person {
  width: 800px;
  max-width: 95vw;
  height: 85vh;
  max-height: 900px;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
}

.wizard-add-person .wizard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  color: white;
}

.wizard-add-person .wizard-header h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
}

.wizard-add-person .wizard-header .close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.wizard-add-person .wizard-header .close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===================== FULL PAGE ELEMENTS ===================== */

.wizard-add-person-page .steps-indicator {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
  flex-shrink: 0;
}

.wizard-add-person-page .step-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 20px;
  background: #E2E8F0;
  transition: all 0.2s;
}

.wizard-add-person-page .step-indicator.active {
  background: #FF6F61;
}

.wizard-add-person-page .step-indicator.completed {
  background: #10B981;
}

.wizard-add-person-page .step-indicator .step-number {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  color: #64748B;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 11px;
  transition: all 0.2s;
}

.wizard-add-person-page .step-indicator.active .step-number,
.wizard-add-person-page .step-indicator.completed .step-number {
  background: rgba(255,255,255,0.3);
  color: white;
}

.wizard-add-person-page .step-indicator .step-label {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-person-page .step-indicator.active .step-label,
.wizard-add-person-page .step-indicator.completed .step-label {
  color: white;
  font-weight: 600;
}

.wizard-add-person-page .wizard-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 24px;
  background: #F8FAFC;
}

.wizard-add-person-page .step-content {
  width: 100%;
  max-width: 100%;
}

/* ===================== FULL PAGE STEP 1: IDENTITY GRID ===================== */

.wizard-add-person-page .step-content.identity-step {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  align-items: start;
}

.wizard-add-person-page .step-content.identity-step .form-section {
  background: white;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid #E2E8F0;
  margin-bottom: 0;
  height: fit-content;
}

.wizard-add-person-page .step-content.identity-step .form-section h4 {
  font-size: 13px;
  margin-bottom: 12px;
  padding-bottom: 8px;
}

.wizard-add-person-page .step-content.identity-step .section-icon {
  width: 22px;
  height: 22px;
  font-size: 11px;
}

.wizard-add-person-page .step-content.identity-step .form-row {
  flex-direction: column;
  gap: 10px;
}

.wizard-add-person-page .step-content.identity-step .form-group {
  margin-bottom: 10px;
}

.wizard-add-person-page .step-content.identity-step .form-group label {
  font-size: 12px;
  margin-bottom: 4px;
}

.wizard-add-person-page .step-content.identity-step .form-group input {
  padding: 10px 12px;
  font-size: 13px;
  border-radius: 8px;
}

.wizard-add-person-page .step-content.identity-step .status-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.wizard-add-person-page .step-content.identity-step .status-card {
  padding: 10px 8px;
  min-width: auto;
  border-radius: 8px;
}

.wizard-add-person-page .step-content.identity-step .status-icon {
  font-size: 18px;
  margin-bottom: 4px;
}

.wizard-add-person-page .step-content.identity-step .status-label {
  font-size: 11px;
}

.wizard-add-person-page .step-content.identity-step .employment-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}

.wizard-add-person-page .step-content.identity-step .employment-card {
  padding: 10px 6px;
  border-radius: 8px;
}

.wizard-add-person-page .step-content.identity-step .employment-icon {
  font-size: 20px;
  margin-bottom: 4px;
}

.wizard-add-person-page .step-content.identity-step .employment-label {
  font-size: 10px;
}

.wizard-add-person-page .step-content.identity-step .employment-card .check-mark {
  width: 16px;
  height: 16px;
  font-size: 10px;
  top: 4px;
  right: 4px;
}

.wizard-add-person-page .step-content.identity-step .children-control {
  width: 100%;
  justify-content: center;
  padding: 10px;
  border-radius: 10px;
  gap: 12px;
}

.wizard-add-person-page .step-content.identity-step .children-btn {
  width: 32px;
  height: 32px;
  font-size: 18px;
}

.wizard-add-person-page .step-content.identity-step .children-count {
  font-size: 24px;
  min-width: 40px;
}

.wizard-add-person-page .step-content.identity-step .checkbox-group {
  margin-top: 10px;
}

.wizard-add-person-page .step-content.identity-step .checkbox-label {
  padding: 10px 14px;
  font-size: 12px;
  border-radius: 8px;
  gap: 8px;
}

.wizard-add-person-page .step-content.identity-step .checkbox-label input {
  width: 16px;
  height: 16px;
}

.wizard-add-person-page .step-content.identity-step .fiscal-parts-display {
  margin-top: 12px;
  padding: 12px 16px;
  border-radius: 10px;
}

.wizard-add-person-page .step-content.identity-step .fiscal-parts-display .label {
  font-size: 12px;
}

.wizard-add-person-page .step-content.identity-step .fiscal-parts-display .parts {
  font-size: 20px;
}

/* ===================== FULL PAGE STEP 2: INCOMES - COLLAPSIBLE CARDS ===================== */

.wizard-add-person-page .step-content.incomes-step {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Add income buttons section - single line per category */
.wizard-add-person-page .income-add-section {
  background: white;
  border-radius: 10px;
  padding: 10px 14px;
  border: 1px solid #E2E8F0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.wizard-add-person-page .income-category-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
}

.wizard-add-person-page .income-category-row .category-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  min-width: 80px;
  flex-shrink: 0;
}

.wizard-add-person-page .income-category-row .category-types {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.wizard-add-person-page .income-add-section .add-type-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 11px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
}

.wizard-add-person-page .income-add-section .add-type-btn:hover {
  background: #E2E8F0;
  border-color: #CBD5E1;
}

.wizard-add-person-page .income-add-section .add-type-btn .btn-icon {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  font-weight: 700;
  color: white;
}

.wizard-add-person-page .income-add-section .add-type-btn .btn-label {
  color: #475569;
}

/* Income sources list */
.wizard-add-person-page .income-sources-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wizard-add-person-page .no-sources-hint {
  background: white;
  border-radius: 10px;
  padding: 32px;
  border: 2px dashed #E2E8F0;
  text-align: center;
}

.wizard-add-person-page .no-sources-hint p {
  font-size: 13px;
  color: #94A3B8;
  margin: 0;
}

/* Income source card */
.wizard-add-person-page .income-source-card {
  background: white;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
  overflow: hidden;
  transition: box-shadow 0.15s;
  caret-color: transparent;
}

.wizard-add-person-page .income-source-card input {
  caret-color: auto;
}

.wizard-add-person-page .income-source-card.expanded {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Source header */
.wizard-add-person-page .source-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;
  gap: 12px;
}

.wizard-add-person-page .source-header:hover {
  background: #F8FAFC;
}

.wizard-add-person-page .source-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
}

.wizard-add-person-page .source-header .source-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.wizard-add-person-page .source-header .source-type {
  font-size: 13px;
  font-weight: 600;
  color: #1E293B;
  min-width: 100px;
}

.wizard-add-person-page .source-header .source-label-input {
  flex: 1 1;
  padding: 6px 10px;
  font-size: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  max-width: 150px;
}

.wizard-add-person-page .source-header .source-label-input:focus {
  outline: none;
  border-color: #3B82F6;
}

.wizard-add-person-page .source-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-person-page .source-header .date-label {
  font-size: 11px;
  color: #64748B;
}

.wizard-add-person-page .source-header .source-date {
  padding: 6px 8px;
  font-size: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  width: 120px;
  transition: all 0.2s;
}

.wizard-add-person-page .source-header .source-date:focus {
  outline: none;
  border-color: #3B82F6;
}

/* Highlight date inputs when empty */
.wizard-add-person-page .income-source-card.needs-dates .source-date {
  border-color: #F59E0B;
  background: #FFFBEB;
  animation: pulse-border 1.5s ease-in-out infinite;
}

@keyframes pulse-border {
  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.4); }
  50% { box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2); }
}

.wizard-add-person-page .source-header .date-sep {
  font-size: 11px;
  color: #94A3B8;
  font-weight: 500;
}

.wizard-add-person-page .source-header .expand-icon {
  font-size: 10px;
  color: #94A3B8;
  transition: transform 0.2s;
  margin-left: 4px;
}

.wizard-add-person-page .source-header .expand-icon.expanded {
  transform: rotate(180deg);
}

.wizard-add-person-page .source-header .remove-source-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #94A3B8;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.15s;
}

.wizard-add-person-page .source-header .remove-source-btn:hover {
  color: #EF4444;
  background: #FEE2E2;
}

/* Dates hint */
.wizard-add-person-page .dates-hint {
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #D97706;
  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
  border-top: 1px solid #FCD34D;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-person-page .dates-hint::before {
  content: '⚠';
  font-size: 14px;
}

/* Source years table */
.wizard-add-person-page .source-years-table {
  border-top: 1px solid #E2E8F0;
  background: #F8FAFC;
  padding: 12px 14px;
}

.wizard-add-person-page .source-years-table .help-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-person-page .source-years-table .help-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #3B82F6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  cursor: help;
  flex-shrink: 0;
}

.wizard-add-person-page .source-years-table .help-text {
  font-size: 11px;
  color: #64748B;
  line-height: 1.4;
}

.wizard-add-person-page .source-years-table table {
  width: 100%;
  border-collapse: collapse;
}

.wizard-add-person-page .source-years-table th {
  text-align: left;
  padding: 8px 10px;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  background: #E2E8F0;
  white-space: nowrap;
}

.wizard-add-person-page .source-years-table th:first-child {
  border-radius: 6px 0 0 6px;
}

.wizard-add-person-page .source-years-table th:last-child {
  border-radius: 0 6px 6px 0;
}

/* Table header classes */
.wizard-add-person-page .source-years-table .th-year { width: 55px; text-align: left; }
.wizard-add-person-page .source-years-table .th-brut { width: 110px; text-align: left; }
.wizard-add-person-page .source-years-table .th-detail { width: 32px; text-align: center; padding: 8px 4px !important; }
.wizard-add-person-page .source-years-table .th-charges { width: 100px; text-align: right; }
.wizard-add-person-page .source-years-table .th-net { width: 110px; text-align: right; }
.wizard-add-person-page .source-years-table .th-taxable { width: 100px; text-align: right; }

/* Help icon in table headers */
.wizard-add-person-page .source-years-table .th-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #94A3B8;
  color: white;
  font-size: 9px;
  font-weight: 700;
  margin-left: 4px;
  cursor: help;
  vertical-align: middle;
}

.wizard-add-person-page .source-years-table .th-help:hover {
  background: #3B82F6;
}

.wizard-add-person-page .source-years-table td {
  padding: 8px 10px;
  font-size: 13px;
  border-bottom: 1px solid #E2E8F0;
  vertical-align: middle;
}

.wizard-add-person-page .source-years-table tr:last-child td {
  border-bottom: none;
}

/* Table cell classes */
.wizard-add-person-page .source-years-table .td-year {
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-person-page .source-years-table .td-brut,
.wizard-add-person-page .source-years-table .td-charges {
  padding: 6px 8px;
}

.wizard-add-person-page .source-years-table .td-net {
  padding: 6px 10px;
  text-align: right;
}

.wizard-add-person-page .source-years-table .td-taxable {
  padding: 6px 10px;
}

.wizard-add-person-page .source-years-table .td-detail {
  text-align: center;
  padding: 6px 4px;
}

.wizard-add-person-page .source-years-table .td-charges,
.wizard-add-person-page .source-years-table .td-net,
.wizard-add-person-page .source-years-table .td-taxable {
  text-align: right;
}

/* Input wrapper with € suffix */
.wizard-add-person-page .source-years-table .input-wrapper {
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  padding-right: 8px;
}

.wizard-add-person-page .source-years-table .input-wrapper input {
  flex: 1 1;
  padding: 6px 8px;
  font-size: 12px;
  border: none;
  background: transparent;
  min-width: 60px;
}

.wizard-add-person-page .source-years-table .input-wrapper input:focus {
  outline: none;
}

.wizard-add-person-page .source-years-table .input-wrapper:focus-within {
  border-color: #3B82F6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

/* Highlight empty amount inputs */
.wizard-add-person-page .source-years-table .input-wrapper.needs-input {
  border-color: #F59E0B;
  background: #FFFBEB;
  animation: pulse-border 1.5s ease-in-out infinite;
}

.wizard-add-person-page .source-years-table .input-wrapper.needs-input input::placeholder {
  color: #D97706;
  font-weight: 500;
}

.wizard-add-person-page .source-years-table .input-suffix {
  font-size: 11px;
  color: #94A3B8;
  font-weight: 500;
}

/* Auto-calculated values */
.wizard-add-person-page .source-years-table .auto-value {
  font-size: 12px;
  color: #64748B;
  padding: 6px 8px;
  background: #F1F5F9;
  border-radius: 4px;
  display: inline-block;
}

.wizard-add-person-page .source-years-table .auto-value.highlight {
  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);
  color: #059669;
  font-weight: 600;
}

.wizard-add-person-page .source-years-table .detail-btn {
  background: #E2E8F0;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #64748B;
  transition: all 0.15s;
}

.wizard-add-person-page .source-years-table .detail-btn:hover {
  background: #3B82F6;
  color: white;
}

.wizard-add-person-page .source-years-table .detail-btn.has-detail {
  background: #10B981;
  color: white;
}

/* Value with formula hint */
.wizard-add-person-page .source-years-table .value-with-formula {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
}

.wizard-add-person-page .source-years-table .formula-hint {
  font-size: 9px;
  color: #94A3B8;
  font-style: italic;
}

/* ===================== FULL PAGE STEP 3: SUMMARY GRID ===================== */

.wizard-add-person-page .step-content.summary-step {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
  align-items: start;
}

.wizard-add-person-page .step-content.summary-step .summary-section {
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #E2E8F0;
  margin-bottom: 0;
}

.wizard-add-person-page .step-content.summary-step .summary-section h4 {
  font-size: 13px;
  margin-bottom: 12px;
}

.wizard-add-person-page .step-content.summary-step .section-icon {
  width: 20px;
  height: 20px;
  font-size: 10px;
}

.wizard-add-person-page .step-content.summary-step .summary-row {
  padding: 8px 0;
}

.wizard-add-person-page .step-content.summary-step .summary-label {
  font-size: 12px;
}

.wizard-add-person-page .step-content.summary-step .summary-value {
  font-size: 13px;
}

.wizard-add-person-page .step-content.summary-step .summary-row.highlight {
  margin: 12px -16px -16px -16px;
  padding: 12px 16px;
  border-radius: 0 0 10px 10px;
}

.wizard-add-person-page .step-content.summary-step .summary-income {
  padding: 8px 0;
  gap: 10px;
}

.wizard-add-person-page .step-content.summary-step .summary-income .income-badge {
  width: 28px;
  height: 28px;
  font-size: 9px;
  border-radius: 6px;
}

.wizard-add-person-page .step-content.summary-step .summary-income .income-type {
  font-size: 13px;
}

.wizard-add-person-page .step-content.summary-step .summary-income .income-label {
  font-size: 11px;
}

.wizard-add-person-page .step-content.summary-step .summary-totals {
  margin-top: 12px;
  padding-top: 12px;
}

.wizard-add-person-page .step-content.summary-step .summary-totals h5 {
  font-size: 11px;
  margin-bottom: 10px;
}

.wizard-add-person-page .step-content.summary-step .summary-year-row {
  padding: 6px 0;
  font-size: 12px;
  gap: 20px;
}

.wizard-add-person-page .step-content.summary-step .no-data {
  font-size: 12px;
}

/* ===================== FULL PAGE NO SOURCES ===================== */

.wizard-add-person-page .step-content.incomes-step .no-sources-hint {
  background: white;
  border-radius: 10px;
  padding: 32px 20px;
  border: 2px dashed #E2E8F0;
  text-align: center;
}

.wizard-add-person-page .step-content.incomes-step .no-sources-hint p {
  font-size: 13px;
  color: #64748B;
}

/* ===================== RESPONSIVE FULL PAGE ===================== */

@media (max-width: 700px) {
  .wizard-add-person-page .step-content.identity-step {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .wizard-add-person-page .step-content.summary-step {
    grid-template-columns: 1fr;
  }

  .wizard-add-person-page .source-header {
    flex-wrap: wrap;
    gap: 8px;
  }

  .wizard-add-person-page .source-header .source-label-input {
    order: 10;
    flex: 1 1 100%;
    max-width: none;
  }
}

.wizard-add-person-page .wizard-footer {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  border-top: 1px solid #E2E8F0;
  background: #F8FAFC;
  flex-shrink: 0;
}

.wizard-add-person-page .footer-spacer {
  flex: 1 1;
}

.wizard-add-person-page .back-btn {
  padding: 10px 20px;
  border: 1px solid #CBD5E1;
  background: white;
  color: #64748B;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person-page .back-btn:hover {
  border-color: #94A3B8;
  color: #475569;
}

.wizard-add-person-page .next-btn,
.wizard-add-person-page .submit-btn {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person-page .next-btn {
  background: #3B82F6;
  color: white;
}

.wizard-add-person-page .next-btn:hover:not(:disabled) {
  background: #2563EB;
}

.wizard-add-person-page .next-btn:disabled {
  background: #CBD5E1;
  cursor: not-allowed;
}

.wizard-add-person-page .submit-btn {
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.wizard-add-person-page .submit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
}

/* Form sections for full-page */
.wizard-add-person-page .form-section {
  margin-bottom: 36px;
}

.wizard-add-person-page .form-section h4 {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  color: #334155;
  margin: 0 0 24px 0;
  padding-bottom: 14px;
  border-bottom: 2px solid #E2E8F0;
}

.wizard-add-person-page .section-icon {
  width: 32px;
  height: 32px;
  background: #FF6F61;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}

.wizard-add-person-page .form-row {
  display: flex;
  gap: 24px;
}

.wizard-add-person-page .form-row .form-group {
  flex: 1 1;
}

.wizard-add-person-page .form-group {
  margin-bottom: 24px;
}

.wizard-add-person-page .form-group label {
  display: block;
  font-size: 15px;
  color: #475569;
  margin-bottom: 10px;
  font-weight: 500;
}

.wizard-add-person-page .form-group input[type="text"],
.wizard-add-person-page .form-group input[type="number"],
.wizard-add-person-page .form-group select {
  width: 100%;
  padding: 16px 18px;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.wizard-add-person-page .form-group input:focus,
.wizard-add-person-page .form-group select:focus {
  outline: none;
  border-color: #FF6F61;
  box-shadow: 0 0 0 4px rgba(255, 111, 97, 0.1);
}

/* Status cards - larger for full page */
.wizard-add-person-page .status-cards {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.wizard-add-person-page .status-card {
  flex: 1 1;
  min-width: 120px;
  padding: 20px 16px;
  border: 2px solid #E2E8F0;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
}

.wizard-add-person-page .status-card:hover {
  border-color: #FF6F61;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.wizard-add-person-page .status-card.selected {
  border-color: #FF6F61;
  background: linear-gradient(180deg, #FFF5F4 0%, white 100%);
  box-shadow: 0 0 0 4px rgba(255, 111, 97, 0.15);
}

.wizard-add-person-page .status-icon {
  font-size: 32px;
  margin-bottom: 10px;
}

.wizard-add-person-page .status-label {
  font-weight: 600;
  color: #334155;
  font-size: 14px;
}

/* Children control - larger */
.wizard-add-person-page .children-control {
  display: inline-flex;
  align-items: center;
  gap: 20px;
  background: #F1F5F9;
  padding: 14px 28px;
  border-radius: 14px;
}

.wizard-add-person-page .children-btn {
  width: 48px;
  height: 48px;
  border: 2px solid #CBD5E1;
  background: white;
  border-radius: 50%;
  font-size: 26px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748B;
}

.wizard-add-person-page .children-btn:hover:not(:disabled) {
  border-color: #FF6F61;
  color: #FF6F61;
}

.wizard-add-person-page .children-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.wizard-add-person-page .children-btn.plus:hover:not(:disabled) {
  background: #FF6F61;
  border-color: #FF6F61;
  color: white;
}

.wizard-add-person-page .children-count {
  font-size: 36px;
  font-weight: 700;
  color: #1E293B;
  min-width: 60px;
  text-align: center;
}

/* Checkbox */
.wizard-add-person-page .checkbox-group {
  margin-top: 20px;
}

.wizard-add-person-page .checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  padding: 16px 22px;
  background: #FFF7F6;
  border-radius: 12px;
  border: 2px solid #FFE5E2;
  transition: all 0.2s;
}

.wizard-add-person-page .checkbox-label:hover {
  background: #FFE5E2;
}

.wizard-add-person-page .checkbox-label input[type="checkbox"] {
  width: 24px;
  height: 24px;
  cursor: pointer;
  accent-color: #FF6F61;
}

/* Fiscal parts display */
.wizard-add-person-page .fiscal-parts-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 32px;
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  border-radius: 16px;
  margin-top: 24px;
  box-shadow: 0 4px 16px rgba(255, 111, 97, 0.3);
}

.wizard-add-person-page .fiscal-parts-display .label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 17px;
  font-weight: 500;
}

.wizard-add-person-page .fiscal-parts-display .parts {
  color: white;
  font-size: 32px;
  font-weight: 700;
}

/* Employment cards */
.wizard-add-person-page .employment-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 14px;
}

.wizard-add-person-page .employment-card {
  padding: 20px 16px;
  border: 2px solid #E2E8F0;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
  position: relative;
}

.wizard-add-person-page .employment-card:hover {
  border-color: #3B82F6;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.wizard-add-person-page .employment-card.selected {
  border-color: #3B82F6;
  background: linear-gradient(180deg, #EFF6FF 0%, white 100%);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}

.wizard-add-person-page .employment-icon {
  font-size: 36px;
  margin-bottom: 10px;
}

.wizard-add-person-page .employment-label {
  font-weight: 600;
  color: #334155;
  font-size: 15px;
}

.wizard-add-person-page .employment-card .check-mark {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  background: #3B82F6;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

.wizard-add-person-page .hint-inline {
  font-size: 13px;
  font-weight: 400;
  color: #94A3B8;
  margin-left: 10px;
}

/* ===================== FULL PAGE STEP 2: INCOMES ===================== */

.wizard-add-person-page .income-sources-header {
  margin-bottom: 28px;
}

.wizard-add-person-page .income-sources-header h4 {
  margin: 0 0 10px 0;
  font-size: 20px;
  color: #1E293B;
  border-bottom: none;
  padding-bottom: 0;
}

.wizard-add-person-page .income-sources-header .hint {
  color: #64748B;
  font-size: 15px;
  margin: 0;
}

.wizard-add-person-page .income-category {
  margin-bottom: 24px;
  background: #F8FAFC;
  border-radius: 14px;
  padding: 20px;
  border: 1px solid #E2E8F0;
}

.wizard-add-person-page .category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.wizard-add-person-page .category-label {
  font-weight: 600;
  font-size: 15px;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wizard-add-person-page .category-add-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.wizard-add-person-page .add-type-btn {
  padding: 10px 16px;
  border: 2px solid #CBD5E1;
  background: white;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-add-person-page .add-type-btn:hover {
  border-color: #3B82F6;
  background: #EFF6FF;
  color: #3B82F6;
}

.wizard-add-person-page .add-type-btn .btn-icon {
  width: 28px;
  height: 28px;
  background: #E2E8F0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
}

.wizard-add-person-page .add-type-btn:hover .btn-icon {
  background: #3B82F6;
  color: white;
}

.wizard-add-person-page .add-type-btn .btn-label {
  font-weight: 500;
}

.wizard-add-person-page .category-sources {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wizard-add-person-page .income-source-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  background: white;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  transition: box-shadow 0.2s;
  flex-wrap: wrap;
}

.wizard-add-person-page .income-source-row:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.wizard-add-person-page .income-source-row .source-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.wizard-add-person-page .income-source-row .source-type {
  font-weight: 600;
  font-size: 15px;
  color: #334155;
  min-width: 120px;
}

.wizard-add-person-page .income-source-row .source-label {
  flex: 1 1;
  padding: 10px 14px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 14px;
  min-width: 140px;
}

.wizard-add-person-page .income-source-row .source-label:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person-page .income-source-row .source-period-label {
  font-size: 13px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-person-page .income-source-row .source-date {
  padding: 10px 14px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 14px;
  width: 150px;
}

.wizard-add-person-page .income-source-row .source-date:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person-page .remove-source-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  opacity: 0.4;
  transition: all 0.2s;
  color: #64748B;
}

.wizard-add-person-page .remove-source-btn:hover {
  opacity: 1;
  background: #FEE2E2;
  color: #DC2626;
}

.wizard-add-person-page .no-sources-hint {
  text-align: center;
  padding: 48px 24px;
  color: #64748B;
}

.wizard-add-person-page .no-sources-hint p {
  margin: 0;
  font-size: 15px;
}

.wizard-add-person-page .generate-tables-section {
  margin-top: 32px;
  text-align: center;
}

.wizard-add-person-page .generate-btn {
  padding: 18px 40px;
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
}

.wizard-add-person-page .generate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(59, 130, 246, 0.4);
}

/* Year tabs sub-step - Full Page */
.wizard-add-person-page .income-years-header {
  margin-bottom: 20px;
}

.wizard-add-person-page .back-to-sources-btn {
  padding: 12px 18px;
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  font-size: 14px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person-page .back-to-sources-btn:hover {
  background: #E2E8F0;
  color: #475569;
}

.wizard-add-person-page .year-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
  padding: 14px;
  background: #F1F5F9;
  border-radius: 14px;
  overflow-x: auto;
}

.wizard-add-person-page .year-tab {
  padding: 14px 28px;
  background: white;
  border: 2px solid #E2E8F0;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.wizard-add-person-page .year-tab:hover {
  border-color: #3B82F6;
  color: #3B82F6;
}

.wizard-add-person-page .year-tab.active {
  background: #3B82F6;
  border-color: #3B82F6;
  color: white;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
}

.wizard-add-person-page .year-table-container {
  background: white;
  border: 2px solid #E2E8F0;
  border-radius: 14px;
  padding: 24px;
}

.wizard-add-person-page .year-table-container h4 {
  margin: 0 0 20px 0;
  font-size: 18px;
  color: #1E293B;
  border-bottom: none;
  padding-bottom: 0;
}

.wizard-add-person-page .year-income-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.wizard-add-person-page .year-income-table thead {
  background: #F8FAFC;
}

.wizard-add-person-page .year-income-table th {
  padding: 14px 12px;
  text-align: left;
  font-weight: 600;
  color: #64748B;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #E2E8F0;
}

.wizard-add-person-page .year-income-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #F1F5F9;
  vertical-align: middle;
}

.wizard-add-person-page .year-income-table .col-type {
  min-width: 180px;
}

.wizard-add-person-page .year-income-table .type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  color: white;
  font-weight: 700;
  font-size: 11px;
  margin-right: 10px;
}

.wizard-add-person-page .year-income-table .type-label {
  font-weight: 500;
  color: #334155;
}

.wizard-add-person-page .year-income-table .source-label-small {
  display: block;
  font-size: 12px;
  color: #64748B;
  margin-top: 4px;
  font-weight: 400;
  margin-left: 46px;
}

.wizard-add-person-page .year-income-table .col-date {
  font-size: 14px;
  color: #64748B;
  text-align: center;
  min-width: 70px;
}

.wizard-add-person-page .year-income-table .col-amount {
  min-width: 140px;
}

.wizard-add-person-page .year-income-table .col-amount input {
  width: 100%;
  padding: 12px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 10px;
  font-size: 15px;
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
}

.wizard-add-person-page .year-income-table .col-amount input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person-page .year-income-table .col-charges {
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
  color: #EF4444;
  min-width: 110px;
}

.wizard-add-person-page .year-income-table .col-taxable {
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
  color: #10B981;
  font-weight: 600;
  min-width: 110px;
}

.wizard-add-person-page .year-income-table .col-detail {
  text-align: center;
  width: 60px;
}

.wizard-add-person-page .detail-btn {
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  font-size: 18px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  color: #64748B;
}

.wizard-add-person-page .detail-btn:hover {
  background: #3B82F6;
  color: white;
  border-color: #3B82F6;
}

.wizard-add-person-page .year-income-table tfoot {
  background: linear-gradient(180deg, #F8FAFC 0%, #EFF6FF 100%);
}

.wizard-add-person-page .year-income-table .totals-row td {
  padding: 18px 12px;
  border-bottom: none;
  border-top: 2px solid #E2E8F0;
}

.wizard-add-person-page .year-income-table .totals-row .col-taxable {
  color: #059669;
}

/* Summary step - Simplified DansMaPoche view */
.wizard-add-person-page .summary-step {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Person header */
.wizard-add-person-page .summary-person-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
  background: white;
  border-radius: 16px;
  border: 1px solid #E2E8F0;
}

.wizard-add-person-page .summary-person-header .person-name {
  font-size: 24px;
  font-weight: 700;
  color: #1E293B;
}

.wizard-add-person-page .summary-person-header .person-info {
  font-size: 14px;
  color: #64748B;
  margin-top: 4px;
}

.wizard-add-person-page .summary-person-header .sources-count {
  font-size: 13px;
  color: #94A3B8;
  margin-top: 8px;
  padding: 4px 12px;
  background: #F1F5F9;
  border-radius: 20px;
}

/* DansMaPoche year cards */
.wizard-add-person-page .dansmapoche-years {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.wizard-add-person-page .dansmapoche-year-card {
  background: white;
  border-radius: 16px;
  border: 1px solid #E2E8F0;
  overflow: hidden;
}

.wizard-add-person-page .dansmapoche-year-card .year-label {
  padding: 12px 20px;
  background: linear-gradient(135deg, #334155 0%, #1E293B 100%);
  color: white;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

.wizard-add-person-page .dansmapoche-year-card .year-breakdown {
  padding: 16px 20px;
}

.wizard-add-person-page .dansmapoche-year-card .breakdown-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #F1F5F9;
}

.wizard-add-person-page .dansmapoche-year-card .breakdown-row:last-child {
  border-bottom: none;
}

.wizard-add-person-page .dansmapoche-year-card .row-label {
  font-size: 14px;
  color: #64748B;
}

.wizard-add-person-page .dansmapoche-year-card .row-value {
  font-size: 16px;
  font-weight: 600;
  color: #1E293B;
}

.wizard-add-person-page .dansmapoche-year-card .row-value.negative {
  color: #DC2626;
}

.wizard-add-person-page .dansmapoche-year-card .row-value.highlight {
  font-size: 20px;
  font-weight: 700;
  color: #059669;
}

.wizard-add-person-page .dansmapoche-year-card .dansmapoche-row {
  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);
  margin: 0 -20px;
  padding: 12px 20px;
  border-bottom: none;
}

.wizard-add-person-page .dansmapoche-year-card .dansmapoche-row .row-label {
  font-weight: 600;
  color: #047857;
}

.wizard-add-person-page .dansmapoche-year-card .monthly-equivalent {
  padding: 10px 20px;
  background: #F8FAFC;
  text-align: center;
  font-size: 13px;
  color: #64748B;
}

/* No data message */
.wizard-add-person-page .no-data-message {
  text-align: center;
  padding: 40px 20px;
  background: white;
  border-radius: 16px;
  border: 1px solid #E2E8F0;
}

.wizard-add-person-page .no-data-message p {
  margin: 8px 0;
  color: #64748B;
}

/* Disclaimer */
.wizard-add-person-page .summary-disclaimer {
  padding: 12px 16px;
  background: #FFFBEB;
  border-radius: 10px;
  border-left: 4px solid #F59E0B;
  font-size: 13px;
  color: #92400E;
  text-align: center;
}

/* Responsive */
@media (max-width: 640px) {
  .wizard-add-person-page .dansmapoche-years {
    grid-template-columns: 1fr;
  }
}

/* Detail Modal - Full Page version */
.detail-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.detail-modal {
  background: white;
  border-radius: 18px;
  width: 480px;
  max-width: 90vw;
  max-height: 80vh;
  overflow: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}

.detail-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid #E2E8F0;
  position: sticky;
  top: 0;
  background: white;
}

.detail-modal-header h4 {
  margin: 0;
  font-size: 20px;
  color: #1E293B;
  display: flex;
  align-items: center;
  gap: 12px;
}

.detail-modal-header .modal-badge {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: white;
}

.detail-modal-header button {
  background: none;
  border: none;
  font-size: 28px;
  color: #94A3B8;
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s;
  line-height: 1;
}

.detail-modal-header button:hover {
  color: #475569;
}

.detail-modal-body {
  padding: 28px;
}

.detail-modal-body .form-group {
  margin-bottom: 20px;
}

.detail-modal-body .form-group label {
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 10px;
}

.detail-modal-body .form-group input[type="text"],
.detail-modal-body .form-group input[type="number"] {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #E2E8F0;
  border-radius: 10px;
  font-size: 16px;
  box-sizing: border-box;
}

.detail-modal-body .form-group input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.detail-modal-body .field-hint {
  font-size: 13px;
  color: #64748B;
  margin-top: 8px;
}

.detail-modal-body .checkbox-group {
  margin-top: 16px;
}

.detail-modal-body .checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 14px 18px;
  background: #F8FAFC;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
  font-size: 14px;
}

.detail-modal-body .checkbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: #3B82F6;
}

.detail-hint {
  font-size: 14px;
  color: #64748B;
  padding: 14px 16px;
  background: #F8FAFC;
  border-radius: 10px;
  margin-top: 12px;
  border: 1px solid #E2E8F0;
}

.detail-modal-footer {
  padding: 20px 28px;
  border-top: 1px solid #E2E8F0;
  display: flex;
  justify-content: flex-end;
}

.detail-modal-footer .close-modal-btn {
  padding: 14px 28px;
  background: #3B82F6;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.detail-modal-footer .close-modal-btn:hover {
  background: #2563EB;
}

/* ===================== LEGACY MODAL STEPS ===================== */

/* Steps indicator */
.wizard-add-person .steps-indicator {
  display: flex;
  justify-content: center;
  gap: 60px;
  padding: 24px 32px;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-person .step-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.wizard-add-person .step-indicator.active,
.wizard-add-person .step-indicator.completed {
  opacity: 1;
}

.wizard-add-person .step-indicator .step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #E2E8F0;
  color: #64748B;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.2s;
}

.wizard-add-person .step-indicator.active .step-number {
  background: #FF6F61;
  color: white;
  box-shadow: 0 4px 12px rgba(255, 111, 97, 0.4);
}

.wizard-add-person .step-indicator.completed .step-number {
  background: #10B981;
  color: white;
}

.wizard-add-person .step-indicator .step-label {
  font-size: 14px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-person .step-indicator.active .step-label {
  color: #FF6F61;
  font-weight: 600;
}

/* Body */
.wizard-add-person .wizard-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 32px 48px;
}

.wizard-add-person .step-content {
  max-width: 700px;
  margin: 0 auto;
}

/* Form sections */
.wizard-add-person .form-section {
  margin-bottom: 32px;
}

.wizard-add-person .form-section h4 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  color: #334155;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #E2E8F0;
}

.wizard-add-person .section-icon {
  font-size: 22px;
}

/* Form elements */
.wizard-add-person .form-row {
  display: flex;
  gap: 20px;
}

.wizard-add-person .form-row .form-group {
  flex: 1 1;
}

.wizard-add-person .form-group {
  margin-bottom: 20px;
}

.wizard-add-person .form-group label {
  display: block;
  font-size: 14px;
  color: #475569;
  margin-bottom: 8px;
  font-weight: 500;
}

.wizard-add-person .form-group input[type="text"],
.wizard-add-person .form-group input[type="number"],
.wizard-add-person .form-group select {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #E2E8F0;
  border-radius: 10px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.wizard-add-person .form-group input:focus,
.wizard-add-person .form-group select:focus {
  outline: none;
  border-color: #FF6F61;
  box-shadow: 0 0 0 4px rgba(255, 111, 97, 0.1);
}

/* Status cards */
.wizard-add-person .status-cards {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.wizard-add-person .status-card {
  flex: 1 1;
  min-width: 100px;
  padding: 16px 12px;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
}

.wizard-add-person .status-card:hover {
  border-color: #FF6F61;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.wizard-add-person .status-card.selected {
  border-color: #FF6F61;
  background: linear-gradient(180deg, #FFF5F4 0%, white 100%);
  box-shadow: 0 0 0 4px rgba(255, 111, 97, 0.15);
}

.wizard-add-person .status-icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.wizard-add-person .status-label {
  font-weight: 600;
  color: #334155;
  font-size: 13px;
}

/* Children control */
.wizard-add-person .children-control {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  background: #F1F5F9;
  padding: 12px 24px;
  border-radius: 12px;
}

.wizard-add-person .children-btn {
  width: 44px;
  height: 44px;
  border: 2px solid #CBD5E1;
  background: white;
  border-radius: 50%;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748B;
}

.wizard-add-person .children-btn:hover:not(:disabled) {
  border-color: #FF6F61;
  color: #FF6F61;
}

.wizard-add-person .children-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.wizard-add-person .children-btn.plus:hover:not(:disabled) {
  background: #FF6F61;
  border-color: #FF6F61;
  color: white;
}

.wizard-add-person .children-count {
  font-size: 32px;
  font-weight: 700;
  color: #1E293B;
  min-width: 50px;
  text-align: center;
}

/* Checkbox */
.wizard-add-person .checkbox-group {
  margin-top: 16px;
}

.wizard-add-person .checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 14px 20px;
  background: #FFF7F6;
  border-radius: 10px;
  border: 2px solid #FFE5E2;
  transition: all 0.2s;
}

.wizard-add-person .checkbox-label:hover {
  background: #FFE5E2;
}

.wizard-add-person .checkbox-label input[type="checkbox"] {
  width: 22px;
  height: 22px;
  cursor: pointer;
  accent-color: #FF6F61;
}

/* Fiscal parts display */
.wizard-add-person .fiscal-parts-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 28px;
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  border-radius: 14px;
  margin-top: 20px;
  box-shadow: 0 4px 16px rgba(255, 111, 97, 0.3);
}

.wizard-add-person .fiscal-parts-display .label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 500;
}

.wizard-add-person .fiscal-parts-display .parts {
  color: white;
  font-size: 28px;
  font-weight: 700;
}

/* Employment cards */
.wizard-add-person .employment-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
}

.wizard-add-person .employment-card {
  padding: 18px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
}

.wizard-add-person .employment-card:hover {
  border-color: #3B82F6;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.wizard-add-person .employment-card.selected {
  border-color: #3B82F6;
  background: linear-gradient(180deg, #EFF6FF 0%, white 100%);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}

.wizard-add-person .employment-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.wizard-add-person .employment-label {
  font-weight: 600;
  color: #334155;
  font-size: 14px;
}

/* Multi-select employment cards */
.wizard-add-person .employment-cards.multi-select .employment-card {
  position: relative;
}

.wizard-add-person .employment-card .check-mark {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  background: #3B82F6;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
}

.wizard-add-person .hint-inline {
  font-size: 12px;
  font-weight: 400;
  color: #94A3B8;
  margin-left: 8px;
}

.wizard-add-person .selection-info {
  margin-top: 16px;
  padding: 12px 16px;
  background: #EFF6FF;
  border-radius: 8px;
  font-size: 13px;
  color: #3B82F6;
  border: 1px solid #BFDBFE;
}

/* Auto-flow progress indicator in income editor */
.wizard-add-person .income-editor h4 {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  color: #1E293B;
  margin: 0 0 20px 0;
}

.wizard-add-person .auto-flow-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #F0FDF4 0%, #ECFDF5 100%);
  border-radius: 10px;
  border: 1px solid #BBF7D0;
}

.wizard-add-person .auto-flow-progress .progress-text {
  font-size: 13px;
  color: #166534;
  font-weight: 500;
}

.wizard-add-person .auto-flow-progress .progress-dots {
  display: flex;
  gap: 6px;
  margin-left: auto;
}

.wizard-add-person .auto-flow-progress .progress-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #D1FAE5;
  border: 2px solid #10B981;
}

.wizard-add-person .auto-flow-progress .progress-dot.completed {
  background: #10B981;
}

.wizard-add-person .auto-flow-progress .progress-dot.current {
  background: #10B981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.3);
}

/* ===================== STEP 2: INCOMES - V2 DESIGN ===================== */

/* Income sources header */
.wizard-add-person .income-sources-header {
  margin-bottom: 24px;
}

.wizard-add-person .income-sources-header h4 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #1E293B;
  border-bottom: none;
  padding-bottom: 0;
}

.wizard-add-person .income-sources-header .hint {
  color: #64748B;
  font-size: 14px;
  margin: 0;
}

/* Income categories */
.wizard-add-person .income-category {
  margin-bottom: 20px;
  background: #F8FAFC;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #E2E8F0;
}

.wizard-add-person .category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.wizard-add-person .category-label {
  font-weight: 600;
  font-size: 14px;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wizard-add-person .category-add-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.wizard-add-person .add-type-btn {
  padding: 8px 14px;
  border: 2px dashed #CBD5E1;
  background: white;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-add-person .add-type-btn:hover {
  border-color: #3B82F6;
  border-style: solid;
  background: #EFF6FF;
  color: #3B82F6;
}

/* Category sources (income rows) */
.wizard-add-person .category-sources {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wizard-add-person .income-source-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: white;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
  transition: box-shadow 0.2s;
}

.wizard-add-person .income-source-row:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.wizard-add-person .income-source-row .source-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
  flex-shrink: 0;
}

.wizard-add-person .income-source-row .source-type {
  font-weight: 600;
  font-size: 14px;
  color: #334155;
  min-width: 100px;
}

.wizard-add-person .income-source-row .source-label {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  min-width: 100px;
}

.wizard-add-person .income-source-row .source-label:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person .income-source-row .source-period-label {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

.wizard-add-person .income-source-row .source-date {
  padding: 8px 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  width: 140px;
}

.wizard-add-person .income-source-row .source-date:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person .remove-source-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  opacity: 0.5;
  transition: all 0.2s;
}

.wizard-add-person .remove-source-btn:hover {
  opacity: 1;
  background: #FEE2E2;
}

/* No sources hint */
.wizard-add-person .no-sources-hint {
  text-align: center;
  padding: 40px 20px;
  color: #64748B;
}

.wizard-add-person .no-sources-hint p {
  margin: 0;
  font-size: 14px;
}

/* Generate tables button */
.wizard-add-person .generate-tables-section {
  margin-top: 24px;
  text-align: center;
}

.wizard-add-person .generate-btn {
  padding: 16px 32px;
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.wizard-add-person .generate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

/* ===================== YEAR TABS SUB-STEP ===================== */

.wizard-add-person .income-years-header {
  margin-bottom: 16px;
}

.wizard-add-person .back-to-sources-btn {
  padding: 10px 16px;
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 14px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person .back-to-sources-btn:hover {
  background: #E2E8F0;
  color: #475569;
}

/* Year tabs */
.wizard-add-person .year-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  padding: 12px;
  background: #F1F5F9;
  border-radius: 12px;
  overflow-x: auto;
}

.wizard-add-person .year-tab {
  padding: 12px 24px;
  background: white;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.wizard-add-person .year-tab:hover {
  border-color: #3B82F6;
  color: #3B82F6;
}

.wizard-add-person .year-tab.active {
  background: #3B82F6;
  border-color: #3B82F6;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* Year table container */
.wizard-add-person .year-table-container {
  background: white;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  padding: 20px;
}

.wizard-add-person .year-table-container h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  color: #1E293B;
  border-bottom: none;
  padding-bottom: 0;
}

/* Year income table */
.wizard-add-person .year-income-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.wizard-add-person .year-income-table thead {
  background: #F8FAFC;
}

.wizard-add-person .year-income-table th {
  padding: 12px 10px;
  text-align: left;
  font-weight: 600;
  color: #64748B;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #E2E8F0;
}

.wizard-add-person .year-income-table td {
  padding: 12px 10px;
  border-bottom: 1px solid #F1F5F9;
  vertical-align: middle;
}

.wizard-add-person .year-income-table .col-type {
  min-width: 150px;
}

.wizard-add-person .year-income-table .type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  color: white;
  font-weight: 600;
  font-size: 12px;
}

.wizard-add-person .year-income-table .source-label-small {
  display: block;
  font-size: 11px;
  color: #64748B;
  margin-top: 4px;
  font-weight: 400;
}

.wizard-add-person .year-income-table .col-date {
  font-size: 13px;
  color: #64748B;
  text-align: center;
  min-width: 60px;
}

.wizard-add-person .year-income-table .col-amount {
  min-width: 120px;
}

.wizard-add-person .year-income-table .col-amount input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 14px;
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
}

.wizard-add-person .year-income-table .col-amount input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person .year-income-table .col-charges {
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
  color: #EF4444;
  min-width: 100px;
}

.wizard-add-person .year-income-table .col-taxable {
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
  color: #10B981;
  font-weight: 600;
  min-width: 100px;
}

.wizard-add-person .year-income-table .col-detail {
  text-align: center;
  width: 50px;
}

.wizard-add-person .detail-btn {
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  font-size: 16px;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person .detail-btn:hover {
  background: #E2E8F0;
}

/* Totals row */
.wizard-add-person .year-income-table tfoot {
  background: linear-gradient(180deg, #F8FAFC 0%, #EFF6FF 100%);
}

.wizard-add-person .year-income-table .totals-row td {
  padding: 16px 10px;
  border-bottom: none;
  border-top: 2px solid #E2E8F0;
}

.wizard-add-person .year-income-table .totals-row .col-taxable {
  color: #059669;
}

/* ===================== DETAIL MODAL ===================== */

.wizard-add-person .detail-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.wizard-add-person .detail-modal {
  background: white;
  border-radius: 16px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.wizard-add-person .detail-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #E2E8F0;
}

.wizard-add-person .detail-modal-header h4 {
  margin: 0;
  font-size: 18px;
  color: #1E293B;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: none;
  padding-bottom: 0;
}

.wizard-add-person .detail-modal-header button {
  background: none;
  border: none;
  font-size: 24px;
  color: #94A3B8;
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s;
}

.wizard-add-person .detail-modal-header button:hover {
  color: #475569;
}

.wizard-add-person .detail-modal-body {
  padding: 24px;
}

.wizard-add-person .detail-modal-body .form-group {
  margin-bottom: 16px;
}

.wizard-add-person .detail-modal-body .form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 8px;
}

.wizard-add-person .detail-modal-body .form-group input {
  width: 100%;
  padding: 12px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 15px;
  box-sizing: border-box;
}

.wizard-add-person .detail-modal-body .form-group input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person .detail-hint {
  font-size: 13px;
  color: #64748B;
  padding: 12px;
  background: #F8FAFC;
  border-radius: 8px;
  margin-top: 8px;
}

.wizard-add-person .detail-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #E2E8F0;
  display: flex;
  justify-content: flex-end;
}

.wizard-add-person .detail-modal-footer button {
  padding: 12px 24px;
  background: #3B82F6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.wizard-add-person .detail-modal-footer button:hover {
  background: #2563EB;
}

/* Summary income label */
.wizard-add-person .summary-income .income-label {
  font-size: 13px;
  color: #64748B;
  font-style: italic;
}

/* ===================== OLD STEP 2 STYLES (kept for compatibility) ===================== */

/* Income type cards */
.wizard-add-person .income-type-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}

.wizard-add-person .income-type-card {
  padding: 16px 12px;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
}

.wizard-add-person .income-type-card:hover {
  border-color: var(--card-color, #3B82F6);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.wizard-add-person .income-type-card.selected {
  border-color: var(--card-color, #3B82F6);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}

.wizard-add-person .income-type-card .type-icon {
  font-size: 28px;
  margin-bottom: 6px;
}

.wizard-add-person .income-type-card .type-label {
  font-weight: 600;
  color: #334155;
  font-size: 13px;
}

/* Specific fields */
.wizard-add-person .specific-fields {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.wizard-add-person .specific-field {
  flex: 1 1;
}

.wizard-add-person .specific-field select {
  width: 100%;
  padding: 12px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 14px;
}

/* Year selector */
.wizard-add-person .year-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px;
  background: #F1F5F9;
  border-radius: 12px;
  margin-bottom: 16px;
}

.wizard-add-person .year-chip {
  position: relative;
  padding: 10px 16px;
  border: 2px solid #E2E8F0;
  background: white;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person .year-chip:hover {
  border-color: #94A3B8;
  color: #334155;
}

.wizard-add-person .year-chip.selected {
  border-color: #3B82F6;
  background: #3B82F6;
  color: white;
}

.wizard-add-person .year-chip.current {
  border-color: #10B981;
}

.wizard-add-person .year-chip.current.selected {
  background: #10B981;
  border-color: #10B981;
}

.wizard-add-person .year-chip .current-badge {
  position: absolute;
  top: -8px;
  right: -4px;
  font-size: 9px;
  background: #10B981;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wizard-add-person .year-chip.selected .current-badge {
  background: white;
  color: #10B981;
}

/* Yearly amounts grid */
.wizard-add-person .yearly-amounts-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #F8FAFC;
  padding: 20px;
  border-radius: 12px;
}

.wizard-add-person .year-amount-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.wizard-add-person .year-label {
  font-weight: 600;
  color: #475569;
  min-width: 50px;
  font-size: 15px;
}

.wizard-add-person .year-amount-row input {
  flex: 0 0 160px;
  padding: 12px 14px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 15px;
}

.wizard-add-person .year-amount-row input:focus {
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person .taxable-preview {
  font-size: 13px;
  color: #10B981;
  font-weight: 500;
}

/* Income editor actions */
.wizard-add-person .income-editor-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #E2E8F0;
}

/* ===================== INCOMES TABLE ===================== */

.wizard-add-person .incomes-table-container {
  margin-bottom: 24px;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
}

.wizard-add-person .incomes-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.wizard-add-person .incomes-table thead {
  background: #F1F5F9;
}

.wizard-add-person .incomes-table th {
  padding: 14px 12px;
  text-align: left;
  font-weight: 600;
  color: #475569;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #E2E8F0;
}

.wizard-add-person .incomes-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #F1F5F9;
  color: #334155;
}

.wizard-add-person .incomes-table .income-row {
  cursor: pointer;
  transition: background 0.2s;
}

.wizard-add-person .incomes-table .income-row:hover {
  background: #F8FAFC;
}

.wizard-add-person .incomes-table .col-type {
  width: 160px;
}

.wizard-add-person .incomes-table .col-period {
  width: 100px;
  text-align: center;
}

.wizard-add-person .incomes-table .col-gross,
.wizard-add-person .incomes-table .col-charges,
.wizard-add-person .incomes-table .col-taxable {
  width: 100px;
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
}

.wizard-add-person .incomes-table .col-taxable {
  color: #10B981;
  font-weight: 600;
}

.wizard-add-person .incomes-table .col-actions {
  width: 50px;
  text-align: center;
}

.wizard-add-person .incomes-table .type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  color: white;
  font-weight: 600;
  font-size: 13px;
}

.wizard-add-person .incomes-table .action-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: background 0.2s;
  opacity: 0.5;
}

.wizard-add-person .incomes-table .income-row:hover .action-btn {
  opacity: 1;
}

.wizard-add-person .incomes-table .action-btn:hover {
  background: #FEE2E2;
}

.wizard-add-person .incomes-table tfoot {
  background: linear-gradient(180deg, #F8FAFC 0%, #EFF6FF 100%);
}

.wizard-add-person .incomes-table .totals-row td {
  padding: 16px 12px;
  border-bottom: none;
  border-top: 2px solid #E2E8F0;
}

.wizard-add-person .incomes-table .totals-row .col-taxable {
  color: #059669;
}

/* ===================== YEARLY AMOUNTS TABLE (Editor) ===================== */

.wizard-add-person .yearly-amounts-table {
  background: #F8FAFC;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
}

.wizard-add-person .yearly-amounts-header {
  display: flex;
  align-items: center;
  padding: 8px 0 12px 0;
  margin-bottom: 8px;
  border-bottom: 2px solid #E2E8F0;
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wizard-add-person .yearly-amounts-header .col-year {
  width: 60px;
}

.wizard-add-person .yearly-amounts-header .col-amount {
  flex: 1 1;
  text-align: center;
}

.wizard-add-person .yearly-amounts-header .col-charges {
  flex: 1 1;
  text-align: center;
}

.wizard-add-person .yearly-amounts-header .col-taxable {
  width: 100px;
  text-align: right;
}

.wizard-add-person .year-amount-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.wizard-add-person .year-amount-row .col-year {
  width: 60px;
  font-weight: 600;
  color: #475569;
  font-size: 15px;
}

.wizard-add-person .year-amount-row .col-amount,
.wizard-add-person .year-amount-row .col-charges {
  flex: 1 1;
  padding: 0 8px;
}

.wizard-add-person .year-amount-row .col-amount input,
.wizard-add-person .year-amount-row .col-charges input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 14px;
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
}

.wizard-add-person .year-amount-row .col-amount input:focus,
.wizard-add-person .year-amount-row .col-charges input:focus {
  border-color: #3B82F6;
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.wizard-add-person .year-amount-row .col-taxable {
  width: 100px;
  text-align: right;
  color: #10B981;
  font-weight: 600;
  font-size: 14px;
  font-family: 'Monaco', 'Menlo', monospace;
}

.wizard-add-person .charges-hint {
  margin-top: 12px;
  padding: 10px 14px;
  background: #FEF3C7;
  border-radius: 8px;
  font-size: 12px;
  color: #92400E;
  border: 1px solid #FCD34D;
}

/* Add income button */
.wizard-add-person .add-income-btn {
  width: 100%;
  padding: 20px;
  border: 3px dashed #CBD5E1;
  background: #F8FAFC;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person .add-income-btn:hover {
  border-color: #3B82F6;
  color: #3B82F6;
  background: #EFF6FF;
}

/* No incomes hint */
.wizard-add-person .no-incomes-hint {
  text-align: center;
  padding: 32px;
  color: #64748B;
}

.wizard-add-person .no-incomes-hint p {
  margin: 0 0 8px 0;
}

.wizard-add-person .no-incomes-hint .hint {
  font-size: 13px;
  color: #94A3B8;
}

/* ===================== STEP 3: SUMMARY ===================== */

.wizard-add-person .summary-step {
  padding: 0;
}

.wizard-add-person .summary-section {
  background: white;
  border: 2px solid #E2E8F0;
  border-radius: 14px;
  padding: 24px;
  margin-bottom: 20px;
}

.wizard-add-person .summary-section h4 {
  margin: 0 0 20px 0;
  border-bottom: none;
  padding-bottom: 0;
}

.wizard-add-person .summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #F1F5F9;
}

.wizard-add-person .summary-row:last-child {
  border-bottom: none;
}

.wizard-add-person .summary-row.highlight {
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  margin: 16px -24px -24px -24px;
  padding: 16px 24px;
  border-radius: 0 0 12px 12px;
}

.wizard-add-person .summary-row.highlight .summary-label,
.wizard-add-person .summary-row.highlight .summary-value {
  color: white;
}

.wizard-add-person .summary-label {
  color: #64748B;
  font-size: 14px;
}

.wizard-add-person .summary-value {
  color: #1E293B;
  font-weight: 600;
  font-size: 15px;
}

.wizard-add-person .summary-income {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
}

.wizard-add-person .summary-income .income-icon {
  font-size: 24px;
}

.wizard-add-person .summary-income .income-type {
  font-weight: 500;
  color: #334155;
}

.wizard-add-person .summary-totals {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #E2E8F0;
}

.wizard-add-person .summary-totals h5 {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wizard-add-person .summary-year-row {
  display: flex;
  gap: 20px;
  padding: 10px 0;
  font-size: 14px;
}

.wizard-add-person .summary-year-row .year {
  font-weight: 600;
  color: #1E293B;
  min-width: 50px;
}

.wizard-add-person .summary-year-row .gross {
  color: #64748B;
}

.wizard-add-person .summary-year-row .taxable {
  color: #10B981;
  font-weight: 600;
}

.wizard-add-person .no-data {
  color: #94A3B8;
  font-style: italic;
}

/* ===================== FOOTER ===================== */

.wizard-add-person .wizard-footer {
  display: flex;
  align-items: center;
  padding: 20px 32px;
  border-top: 2px solid #E2E8F0;
  background: #F8FAFC;
}

.wizard-add-person .footer-spacer {
  flex: 1 1;
}

.wizard-add-person .back-btn {
  padding: 14px 28px;
  border: 2px solid #CBD5E1;
  background: white;
  color: #64748B;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person .back-btn:hover {
  border-color: #94A3B8;
  color: #475569;
}

.wizard-add-person .next-btn,
.wizard-add-person .submit-btn {
  padding: 14px 32px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-add-person .next-btn {
  background: #3B82F6;
  color: white;
}

.wizard-add-person .next-btn:hover:not(:disabled) {
  background: #2563EB;
}

.wizard-add-person .next-btn:disabled {
  background: #CBD5E1;
  cursor: not-allowed;
}

.wizard-add-person .submit-btn {
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.wizard-add-person .submit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
}

/* Buttons in income editor */
.wizard-add-person .income-editor .cancel-btn {
  padding: 12px 24px;
  border: 2px solid #CBD5E1;
  background: white;
  color: #64748B;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.wizard-add-person .income-editor .save-btn {
  padding: 12px 24px;
  border: none;
  background: #3B82F6;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.wizard-add-person .income-editor .save-btn:disabled {
  background: #CBD5E1;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 800px) {
  .modal-content.wizard-add-person {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }

  .wizard-add-person .wizard-body {
    padding: 24px;
  }

  .wizard-add-person .steps-indicator {
    gap: 24px;
    padding: 16px;
  }

  .wizard-add-person .status-cards {
    flex-wrap: wrap;
  }

  .wizard-add-person .status-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 6px);
  }

  .wizard-add-person .year-amount-row {
    flex-wrap: wrap;
  }

  .wizard-add-person .year-amount-row input {
    flex: 1 1;
    min-width: 120px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Person/WizardAddPerson.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C,gCAAgC;;AAEhC,iEAAiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,uCAAuC;EACvC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA,sCAAsC;AACtC;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,KAAK,mBAAmB,EAAE,2CAA2C,EAAE;EACvE,MAAM,sBAAsB,EAAE,gDAAgD,EAAE;EAChF,OAAO,mBAAmB,EAAE,yCAAyC,EAAE;AACzE;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wEAAwE;;AAExE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,8FAA8F;;AAE9F;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0DAA0D;AAC1D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB,uDAAuD,WAAW,EAAE,gBAAgB,EAAE;AACtF,uDAAuD,YAAY,EAAE,gBAAgB,EAAE;AACvF,yDAAyD,WAAW,EAAE,kBAAkB,EAAE,2BAA2B,EAAE;AACvH,0DAA0D,YAAY,EAAE,iBAAiB,EAAE;AAC3F,sDAAsD,YAAY,EAAE,iBAAiB,EAAE;AACvF,0DAA0D,YAAY,EAAE,iBAAiB,EAAE;;AAE3F,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA,qEAAqE;;AAErE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qEAAqE;;AAErE;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,2DAA2D;EAC3D,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,2DAA2D;EAC3D,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,0EAA0E;;AAE1E;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mEAAmE;;AAEnE,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,2DAA2D;EAC3D,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,2DAA2D;EAC3D,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,4EAA4E;;AAE5E,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,mEAAmE;;AAEnE;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,2FAA2F;;AAE3F,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,8DAA8D;;AAE9D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA,8EAA8E;;AAE9E;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,SAAO;EACP,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,gEAAgE;;AAEhE;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;AACF","sourcesContent":["/* src/components/Person/WizardAddPerson.css */\n/* Full-page multi-step wizard */\n\n/* ===================== FULL PAGE LAYOUT ===================== */\n\n.wizard-add-person-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background: white;\n  overflow: hidden;\n}\n\n/* Topbar - Title left, Steps center, Save/Close right */\n.wizard-add-person-page .wizard-topbar {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  color: white;\n  flex-shrink: 0;\n  gap: 20px;\n}\n\n.wizard-add-person-page .topbar-left {\n  display: flex;\n  align-items: center;\n}\n\n.wizard-add-person-page .topbar-left h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Step indicators - CENTERED in middle column */\n.wizard-add-person-page .steps-indicator {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  padding: 0;\n  background: none;\n  border: none;\n}\n\n.wizard-add-person-page .step-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 24px;\n  background: rgba(255,255,255,0.2);\n  border: 2px solid rgba(255,255,255,0.3);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person-page .step-indicator:hover {\n  background: rgba(255,255,255,0.3);\n}\n\n.wizard-add-person-page .step-indicator.active {\n  background: white;\n  border-color: white;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.wizard-add-person-page .step-indicator.active .step-number {\n  background: #FF6F61;\n  color: white;\n}\n\n.wizard-add-person-page .step-indicator.active .step-label {\n  color: #FF6F61;\n  font-weight: 600;\n}\n\n.wizard-add-person-page .step-indicator.completed {\n  background: #10B981;\n  border-color: #10B981;\n}\n\n.wizard-add-person-page .step-indicator .step-number {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.3);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.wizard-add-person-page .step-indicator.completed .step-number {\n  background: rgba(255,255,255,0.3);\n}\n\n.wizard-add-person-page .step-indicator .step-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n}\n\n.wizard-add-person-page .topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.wizard-add-person-page .save-draft-btn {\n  padding: 8px 20px;\n  background: rgba(255,255,255,0.2);\n  border: 1px solid rgba(255,255,255,0.4);\n  color: white;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 110px;\n}\n\n.wizard-add-person-page .save-draft-btn:hover:not(:disabled) {\n  background: rgba(255,255,255,0.35);\n  transform: translateY(-1px);\n}\n\n.wizard-add-person-page .save-draft-btn:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n/* Saving state - subtle pulse animation */\n.wizard-add-person-page .save-draft-btn.saving {\n  background: rgba(255,255,255,0.15);\n  animation: wizardSavingPulse 1s ease-in-out infinite;\n}\n\n@keyframes wizardSavingPulse {\n  0%, 100% { opacity: 0.7; }\n  50% { opacity: 1; }\n}\n\n/* Success state - brief green flash */\n.wizard-add-person-page .save-draft-btn.success {\n  background: rgba(16, 185, 129, 0.7);\n  border-color: rgba(16, 185, 129, 0.9);\n  animation: wizardSuccessFlash 0.4s ease-out;\n}\n\n@keyframes wizardSuccessFlash {\n  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.6); }\n  50% { transform: scale(1.05); box-shadow: 0 0 20px 4px rgba(16, 185, 129, 0.4); }\n  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }\n}\n\n.wizard-add-person-page .topbar-right .close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.wizard-add-person-page .topbar-right .close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ===================== COMPACT PERSON INFO BAR ===================== */\n\n.wizard-add-person-page .person-info-bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 24px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  flex-wrap: wrap;\n  margin: 20px 0;\n}\n\n.wizard-add-person-page .info-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-person-page .info-separator {\n  width: 1px;\n  height: 32px;\n  background: #E2E8F0;\n}\n\n/* Identity inputs */\n.wizard-add-person-page .identity-group .name-input {\n  padding: 10px 14px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  width: 160px;\n  transition: border-color 0.2s;\n}\n\n.wizard-add-person-page .identity-group .name-input:focus {\n  outline: none;\n  border-color: #FF6F61;\n}\n\n/* Status chips */\n.wizard-add-person-page .status-group .status-chip {\n  width: 40px;\n  height: 40px;\n  border: 2px solid #E2E8F0;\n  border-radius: 10px;\n  background: white;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all 0.15s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wizard-add-person-page .status-group .status-chip:hover {\n  border-color: #FF6F61;\n  background: #FFF5F4;\n}\n\n.wizard-add-person-page .status-group .status-chip.selected {\n  border-color: #FF6F61;\n  background: #FF6F61;\n}\n\n/* Children control */\n.wizard-add-person-page .children-group .children-label {\n  font-size: 13px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-person-page .children-group .child-btn {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: white;\n  font-size: 18px;\n  font-weight: 600;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-person-page .children-group .child-btn:hover:not(:disabled) {\n  border-color: #FF6F61;\n  color: #FF6F61;\n}\n\n.wizard-add-person-page .children-group .child-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.wizard-add-person-page .children-group .child-count {\n  font-size: 18px;\n  font-weight: 600;\n  min-width: 24px;\n  text-align: center;\n}\n\n/* Single parent checkbox */\n.wizard-add-person-page .single-parent-check {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #64748B;\n  cursor: pointer;\n}\n\n.wizard-add-person-page .single-parent-check input {\n  width: 16px;\n  height: 16px;\n  accent-color: #FF6F61;\n}\n\n/* Fiscal badge */\n.wizard-add-person-page .fiscal-badge {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  border-radius: 24px;\n  color: white;\n}\n\n.wizard-add-person-page .fiscal-badge .fiscal-value {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.wizard-add-person-page .fiscal-badge .fiscal-unit {\n  font-size: 12px;\n  font-weight: 500;\n  opacity: 0.9;\n}\n\n/* Legacy modal support - kept for compatibility */\n.modal-content.wizard-add-person {\n  width: 800px;\n  max-width: 95vw;\n  height: 85vh;\n  max-height: 900px;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.wizard-add-person .wizard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 32px;\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  color: white;\n}\n\n.wizard-add-person .wizard-header h3 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.wizard-add-person .wizard-header .close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: white;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.wizard-add-person .wizard-header .close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ===================== FULL PAGE ELEMENTS ===================== */\n\n.wizard-add-person-page .steps-indicator {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 24px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n  flex-shrink: 0;\n}\n\n.wizard-add-person-page .step-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  padding: 6px 14px;\n  border-radius: 20px;\n  background: #E2E8F0;\n  transition: all 0.2s;\n}\n\n.wizard-add-person-page .step-indicator.active {\n  background: #FF6F61;\n}\n\n.wizard-add-person-page .step-indicator.completed {\n  background: #10B981;\n}\n\n.wizard-add-person-page .step-indicator .step-number {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.3);\n  color: #64748B;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 11px;\n  transition: all 0.2s;\n}\n\n.wizard-add-person-page .step-indicator.active .step-number,\n.wizard-add-person-page .step-indicator.completed .step-number {\n  background: rgba(255,255,255,0.3);\n  color: white;\n}\n\n.wizard-add-person-page .step-indicator .step-label {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-person-page .step-indicator.active .step-label,\n.wizard-add-person-page .step-indicator.completed .step-label {\n  color: white;\n  font-weight: 600;\n}\n\n.wizard-add-person-page .wizard-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 24px;\n  background: #F8FAFC;\n}\n\n.wizard-add-person-page .step-content {\n  width: 100%;\n  max-width: 100%;\n}\n\n/* ===================== FULL PAGE STEP 1: IDENTITY GRID ===================== */\n\n.wizard-add-person-page .step-content.identity-step {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  align-items: start;\n}\n\n.wizard-add-person-page .step-content.identity-step .form-section {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  border: 1px solid #E2E8F0;\n  margin-bottom: 0;\n  height: fit-content;\n}\n\n.wizard-add-person-page .step-content.identity-step .form-section h4 {\n  font-size: 13px;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n}\n\n.wizard-add-person-page .step-content.identity-step .section-icon {\n  width: 22px;\n  height: 22px;\n  font-size: 11px;\n}\n\n.wizard-add-person-page .step-content.identity-step .form-row {\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wizard-add-person-page .step-content.identity-step .form-group {\n  margin-bottom: 10px;\n}\n\n.wizard-add-person-page .step-content.identity-step .form-group label {\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.wizard-add-person-page .step-content.identity-step .form-group input {\n  padding: 10px 12px;\n  font-size: 13px;\n  border-radius: 8px;\n}\n\n.wizard-add-person-page .step-content.identity-step .status-cards {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.wizard-add-person-page .step-content.identity-step .status-card {\n  padding: 10px 8px;\n  min-width: auto;\n  border-radius: 8px;\n}\n\n.wizard-add-person-page .step-content.identity-step .status-icon {\n  font-size: 18px;\n  margin-bottom: 4px;\n}\n\n.wizard-add-person-page .step-content.identity-step .status-label {\n  font-size: 11px;\n}\n\n.wizard-add-person-page .step-content.identity-step .employment-cards {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 6px;\n}\n\n.wizard-add-person-page .step-content.identity-step .employment-card {\n  padding: 10px 6px;\n  border-radius: 8px;\n}\n\n.wizard-add-person-page .step-content.identity-step .employment-icon {\n  font-size: 20px;\n  margin-bottom: 4px;\n}\n\n.wizard-add-person-page .step-content.identity-step .employment-label {\n  font-size: 10px;\n}\n\n.wizard-add-person-page .step-content.identity-step .employment-card .check-mark {\n  width: 16px;\n  height: 16px;\n  font-size: 10px;\n  top: 4px;\n  right: 4px;\n}\n\n.wizard-add-person-page .step-content.identity-step .children-control {\n  width: 100%;\n  justify-content: center;\n  padding: 10px;\n  border-radius: 10px;\n  gap: 12px;\n}\n\n.wizard-add-person-page .step-content.identity-step .children-btn {\n  width: 32px;\n  height: 32px;\n  font-size: 18px;\n}\n\n.wizard-add-person-page .step-content.identity-step .children-count {\n  font-size: 24px;\n  min-width: 40px;\n}\n\n.wizard-add-person-page .step-content.identity-step .checkbox-group {\n  margin-top: 10px;\n}\n\n.wizard-add-person-page .step-content.identity-step .checkbox-label {\n  padding: 10px 14px;\n  font-size: 12px;\n  border-radius: 8px;\n  gap: 8px;\n}\n\n.wizard-add-person-page .step-content.identity-step .checkbox-label input {\n  width: 16px;\n  height: 16px;\n}\n\n.wizard-add-person-page .step-content.identity-step .fiscal-parts-display {\n  margin-top: 12px;\n  padding: 12px 16px;\n  border-radius: 10px;\n}\n\n.wizard-add-person-page .step-content.identity-step .fiscal-parts-display .label {\n  font-size: 12px;\n}\n\n.wizard-add-person-page .step-content.identity-step .fiscal-parts-display .parts {\n  font-size: 20px;\n}\n\n/* ===================== FULL PAGE STEP 2: INCOMES - COLLAPSIBLE CARDS ===================== */\n\n.wizard-add-person-page .step-content.incomes-step {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Add income buttons section - single line per category */\n.wizard-add-person-page .income-add-section {\n  background: white;\n  border-radius: 10px;\n  padding: 10px 14px;\n  border: 1px solid #E2E8F0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.wizard-add-person-page .income-category-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 0;\n}\n\n.wizard-add-person-page .income-category-row .category-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n.wizard-add-person-page .income-category-row .category-types {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.wizard-add-person-page .income-add-section .add-type-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  font-size: 11px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.wizard-add-person-page .income-add-section .add-type-btn:hover {\n  background: #E2E8F0;\n  border-color: #CBD5E1;\n}\n\n.wizard-add-person-page .income-add-section .add-type-btn .btn-icon {\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 8px;\n  font-weight: 700;\n  color: white;\n}\n\n.wizard-add-person-page .income-add-section .add-type-btn .btn-label {\n  color: #475569;\n}\n\n/* Income sources list */\n.wizard-add-person-page .income-sources-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wizard-add-person-page .no-sources-hint {\n  background: white;\n  border-radius: 10px;\n  padding: 32px;\n  border: 2px dashed #E2E8F0;\n  text-align: center;\n}\n\n.wizard-add-person-page .no-sources-hint p {\n  font-size: 13px;\n  color: #94A3B8;\n  margin: 0;\n}\n\n/* Income source card */\n.wizard-add-person-page .income-source-card {\n  background: white;\n  border-radius: 10px;\n  border: 1px solid #E2E8F0;\n  overflow: hidden;\n  transition: box-shadow 0.15s;\n  caret-color: transparent;\n}\n\n.wizard-add-person-page .income-source-card input {\n  caret-color: auto;\n}\n\n.wizard-add-person-page .income-source-card.expanded {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n/* Source header */\n.wizard-add-person-page .source-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  cursor: pointer;\n  gap: 12px;\n}\n\n.wizard-add-person-page .source-header:hover {\n  background: #F8FAFC;\n}\n\n.wizard-add-person-page .source-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n}\n\n.wizard-add-person-page .source-header .source-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  font-weight: 700;\n  color: white;\n  flex-shrink: 0;\n}\n\n.wizard-add-person-page .source-header .source-type {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1E293B;\n  min-width: 100px;\n}\n\n.wizard-add-person-page .source-header .source-label-input {\n  flex: 1;\n  padding: 6px 10px;\n  font-size: 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  max-width: 150px;\n}\n\n.wizard-add-person-page .source-header .source-label-input:focus {\n  outline: none;\n  border-color: #3B82F6;\n}\n\n.wizard-add-person-page .source-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-person-page .source-header .date-label {\n  font-size: 11px;\n  color: #64748B;\n}\n\n.wizard-add-person-page .source-header .source-date {\n  padding: 6px 8px;\n  font-size: 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  width: 120px;\n  transition: all 0.2s;\n}\n\n.wizard-add-person-page .source-header .source-date:focus {\n  outline: none;\n  border-color: #3B82F6;\n}\n\n/* Highlight date inputs when empty */\n.wizard-add-person-page .income-source-card.needs-dates .source-date {\n  border-color: #F59E0B;\n  background: #FFFBEB;\n  animation: pulse-border 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-border {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.4); }\n  50% { box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2); }\n}\n\n.wizard-add-person-page .source-header .date-sep {\n  font-size: 11px;\n  color: #94A3B8;\n  font-weight: 500;\n}\n\n.wizard-add-person-page .source-header .expand-icon {\n  font-size: 10px;\n  color: #94A3B8;\n  transition: transform 0.2s;\n  margin-left: 4px;\n}\n\n.wizard-add-person-page .source-header .expand-icon.expanded {\n  transform: rotate(180deg);\n}\n\n.wizard-add-person-page .source-header .remove-source-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #94A3B8;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n\n.wizard-add-person-page .source-header .remove-source-btn:hover {\n  color: #EF4444;\n  background: #FEE2E2;\n}\n\n/* Dates hint */\n.wizard-add-person-page .dates-hint {\n  padding: 10px 14px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #D97706;\n  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);\n  border-top: 1px solid #FCD34D;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-person-page .dates-hint::before {\n  content: '⚠';\n  font-size: 14px;\n}\n\n/* Source years table */\n.wizard-add-person-page .source-years-table {\n  border-top: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  padding: 12px 14px;\n}\n\n.wizard-add-person-page .source-years-table .help-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-person-page .source-years-table .help-icon {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #3B82F6;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  cursor: help;\n  flex-shrink: 0;\n}\n\n.wizard-add-person-page .source-years-table .help-text {\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.wizard-add-person-page .source-years-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.wizard-add-person-page .source-years-table th {\n  text-align: left;\n  padding: 8px 10px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  background: #E2E8F0;\n  white-space: nowrap;\n}\n\n.wizard-add-person-page .source-years-table th:first-child {\n  border-radius: 6px 0 0 6px;\n}\n\n.wizard-add-person-page .source-years-table th:last-child {\n  border-radius: 0 6px 6px 0;\n}\n\n/* Table header classes */\n.wizard-add-person-page .source-years-table .th-year { width: 55px; text-align: left; }\n.wizard-add-person-page .source-years-table .th-brut { width: 110px; text-align: left; }\n.wizard-add-person-page .source-years-table .th-detail { width: 32px; text-align: center; padding: 8px 4px !important; }\n.wizard-add-person-page .source-years-table .th-charges { width: 100px; text-align: right; }\n.wizard-add-person-page .source-years-table .th-net { width: 110px; text-align: right; }\n.wizard-add-person-page .source-years-table .th-taxable { width: 100px; text-align: right; }\n\n/* Help icon in table headers */\n.wizard-add-person-page .source-years-table .th-help {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #94A3B8;\n  color: white;\n  font-size: 9px;\n  font-weight: 700;\n  margin-left: 4px;\n  cursor: help;\n  vertical-align: middle;\n}\n\n.wizard-add-person-page .source-years-table .th-help:hover {\n  background: #3B82F6;\n}\n\n.wizard-add-person-page .source-years-table td {\n  padding: 8px 10px;\n  font-size: 13px;\n  border-bottom: 1px solid #E2E8F0;\n  vertical-align: middle;\n}\n\n.wizard-add-person-page .source-years-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Table cell classes */\n.wizard-add-person-page .source-years-table .td-year {\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-person-page .source-years-table .td-brut,\n.wizard-add-person-page .source-years-table .td-charges {\n  padding: 6px 8px;\n}\n\n.wizard-add-person-page .source-years-table .td-net {\n  padding: 6px 10px;\n  text-align: right;\n}\n\n.wizard-add-person-page .source-years-table .td-taxable {\n  padding: 6px 10px;\n}\n\n.wizard-add-person-page .source-years-table .td-detail {\n  text-align: center;\n  padding: 6px 4px;\n}\n\n.wizard-add-person-page .source-years-table .td-charges,\n.wizard-add-person-page .source-years-table .td-net,\n.wizard-add-person-page .source-years-table .td-taxable {\n  text-align: right;\n}\n\n/* Input wrapper with € suffix */\n.wizard-add-person-page .source-years-table .input-wrapper {\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  padding-right: 8px;\n}\n\n.wizard-add-person-page .source-years-table .input-wrapper input {\n  flex: 1;\n  padding: 6px 8px;\n  font-size: 12px;\n  border: none;\n  background: transparent;\n  min-width: 60px;\n}\n\n.wizard-add-person-page .source-years-table .input-wrapper input:focus {\n  outline: none;\n}\n\n.wizard-add-person-page .source-years-table .input-wrapper:focus-within {\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n/* Highlight empty amount inputs */\n.wizard-add-person-page .source-years-table .input-wrapper.needs-input {\n  border-color: #F59E0B;\n  background: #FFFBEB;\n  animation: pulse-border 1.5s ease-in-out infinite;\n}\n\n.wizard-add-person-page .source-years-table .input-wrapper.needs-input input::placeholder {\n  color: #D97706;\n  font-weight: 500;\n}\n\n.wizard-add-person-page .source-years-table .input-suffix {\n  font-size: 11px;\n  color: #94A3B8;\n  font-weight: 500;\n}\n\n/* Auto-calculated values */\n.wizard-add-person-page .source-years-table .auto-value {\n  font-size: 12px;\n  color: #64748B;\n  padding: 6px 8px;\n  background: #F1F5F9;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.wizard-add-person-page .source-years-table .auto-value.highlight {\n  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);\n  color: #059669;\n  font-weight: 600;\n}\n\n.wizard-add-person-page .source-years-table .detail-btn {\n  background: #E2E8F0;\n  border: none;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #64748B;\n  transition: all 0.15s;\n}\n\n.wizard-add-person-page .source-years-table .detail-btn:hover {\n  background: #3B82F6;\n  color: white;\n}\n\n.wizard-add-person-page .source-years-table .detail-btn.has-detail {\n  background: #10B981;\n  color: white;\n}\n\n/* Value with formula hint */\n.wizard-add-person-page .source-years-table .value-with-formula {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1px;\n}\n\n.wizard-add-person-page .source-years-table .formula-hint {\n  font-size: 9px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n/* ===================== FULL PAGE STEP 3: SUMMARY GRID ===================== */\n\n.wizard-add-person-page .step-content.summary-step {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-section {\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n  margin-bottom: 0;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-section h4 {\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n\n.wizard-add-person-page .step-content.summary-step .section-icon {\n  width: 20px;\n  height: 20px;\n  font-size: 10px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-row {\n  padding: 8px 0;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-label {\n  font-size: 12px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-value {\n  font-size: 13px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-row.highlight {\n  margin: 12px -16px -16px -16px;\n  padding: 12px 16px;\n  border-radius: 0 0 10px 10px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-income {\n  padding: 8px 0;\n  gap: 10px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-income .income-badge {\n  width: 28px;\n  height: 28px;\n  font-size: 9px;\n  border-radius: 6px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-income .income-type {\n  font-size: 13px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-income .income-label {\n  font-size: 11px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-totals {\n  margin-top: 12px;\n  padding-top: 12px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-totals h5 {\n  font-size: 11px;\n  margin-bottom: 10px;\n}\n\n.wizard-add-person-page .step-content.summary-step .summary-year-row {\n  padding: 6px 0;\n  font-size: 12px;\n  gap: 20px;\n}\n\n.wizard-add-person-page .step-content.summary-step .no-data {\n  font-size: 12px;\n}\n\n/* ===================== FULL PAGE NO SOURCES ===================== */\n\n.wizard-add-person-page .step-content.incomes-step .no-sources-hint {\n  background: white;\n  border-radius: 10px;\n  padding: 32px 20px;\n  border: 2px dashed #E2E8F0;\n  text-align: center;\n}\n\n.wizard-add-person-page .step-content.incomes-step .no-sources-hint p {\n  font-size: 13px;\n  color: #64748B;\n}\n\n/* ===================== RESPONSIVE FULL PAGE ===================== */\n\n@media (max-width: 700px) {\n  .wizard-add-person-page .step-content.identity-step {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .wizard-add-person-page .step-content.summary-step {\n    grid-template-columns: 1fr;\n  }\n\n  .wizard-add-person-page .source-header {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .wizard-add-person-page .source-header .source-label-input {\n    order: 10;\n    flex: 1 1 100%;\n    max-width: none;\n  }\n}\n\n.wizard-add-person-page .wizard-footer {\n  display: flex;\n  align-items: center;\n  padding: 12px 24px;\n  border-top: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  flex-shrink: 0;\n}\n\n.wizard-add-person-page .footer-spacer {\n  flex: 1;\n}\n\n.wizard-add-person-page .back-btn {\n  padding: 10px 20px;\n  border: 1px solid #CBD5E1;\n  background: white;\n  color: #64748B;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person-page .back-btn:hover {\n  border-color: #94A3B8;\n  color: #475569;\n}\n\n.wizard-add-person-page .next-btn,\n.wizard-add-person-page .submit-btn {\n  padding: 10px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person-page .next-btn {\n  background: #3B82F6;\n  color: white;\n}\n\n.wizard-add-person-page .next-btn:hover:not(:disabled) {\n  background: #2563EB;\n}\n\n.wizard-add-person-page .next-btn:disabled {\n  background: #CBD5E1;\n  cursor: not-allowed;\n}\n\n.wizard-add-person-page .submit-btn {\n  background: linear-gradient(135deg, #10B981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.wizard-add-person-page .submit-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\n}\n\n/* Form sections for full-page */\n.wizard-add-person-page .form-section {\n  margin-bottom: 36px;\n}\n\n.wizard-add-person-page .form-section h4 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 18px;\n  color: #334155;\n  margin: 0 0 24px 0;\n  padding-bottom: 14px;\n  border-bottom: 2px solid #E2E8F0;\n}\n\n.wizard-add-person-page .section-icon {\n  width: 32px;\n  height: 32px;\n  background: #FF6F61;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.wizard-add-person-page .form-row {\n  display: flex;\n  gap: 24px;\n}\n\n.wizard-add-person-page .form-row .form-group {\n  flex: 1;\n}\n\n.wizard-add-person-page .form-group {\n  margin-bottom: 24px;\n}\n\n.wizard-add-person-page .form-group label {\n  display: block;\n  font-size: 15px;\n  color: #475569;\n  margin-bottom: 10px;\n  font-weight: 500;\n}\n\n.wizard-add-person-page .form-group input[type=\"text\"],\n.wizard-add-person-page .form-group input[type=\"number\"],\n.wizard-add-person-page .form-group select {\n  width: 100%;\n  padding: 16px 18px;\n  border: 2px solid #E2E8F0;\n  border-radius: 12px;\n  font-size: 16px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-sizing: border-box;\n}\n\n.wizard-add-person-page .form-group input:focus,\n.wizard-add-person-page .form-group select:focus {\n  outline: none;\n  border-color: #FF6F61;\n  box-shadow: 0 0 0 4px rgba(255, 111, 97, 0.1);\n}\n\n/* Status cards - larger for full page */\n.wizard-add-person-page .status-cards {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-person-page .status-card {\n  flex: 1;\n  min-width: 120px;\n  padding: 20px 16px;\n  border: 2px solid #E2E8F0;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background: white;\n}\n\n.wizard-add-person-page .status-card:hover {\n  border-color: #FF6F61;\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n.wizard-add-person-page .status-card.selected {\n  border-color: #FF6F61;\n  background: linear-gradient(180deg, #FFF5F4 0%, white 100%);\n  box-shadow: 0 0 0 4px rgba(255, 111, 97, 0.15);\n}\n\n.wizard-add-person-page .status-icon {\n  font-size: 32px;\n  margin-bottom: 10px;\n}\n\n.wizard-add-person-page .status-label {\n  font-weight: 600;\n  color: #334155;\n  font-size: 14px;\n}\n\n/* Children control - larger */\n.wizard-add-person-page .children-control {\n  display: inline-flex;\n  align-items: center;\n  gap: 20px;\n  background: #F1F5F9;\n  padding: 14px 28px;\n  border-radius: 14px;\n}\n\n.wizard-add-person-page .children-btn {\n  width: 48px;\n  height: 48px;\n  border: 2px solid #CBD5E1;\n  background: white;\n  border-radius: 50%;\n  font-size: 26px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748B;\n}\n\n.wizard-add-person-page .children-btn:hover:not(:disabled) {\n  border-color: #FF6F61;\n  color: #FF6F61;\n}\n\n.wizard-add-person-page .children-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.wizard-add-person-page .children-btn.plus:hover:not(:disabled) {\n  background: #FF6F61;\n  border-color: #FF6F61;\n  color: white;\n}\n\n.wizard-add-person-page .children-count {\n  font-size: 36px;\n  font-weight: 700;\n  color: #1E293B;\n  min-width: 60px;\n  text-align: center;\n}\n\n/* Checkbox */\n.wizard-add-person-page .checkbox-group {\n  margin-top: 20px;\n}\n\n.wizard-add-person-page .checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  cursor: pointer;\n  padding: 16px 22px;\n  background: #FFF7F6;\n  border-radius: 12px;\n  border: 2px solid #FFE5E2;\n  transition: all 0.2s;\n}\n\n.wizard-add-person-page .checkbox-label:hover {\n  background: #FFE5E2;\n}\n\n.wizard-add-person-page .checkbox-label input[type=\"checkbox\"] {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  accent-color: #FF6F61;\n}\n\n/* Fiscal parts display */\n.wizard-add-person-page .fiscal-parts-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 22px 32px;\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  border-radius: 16px;\n  margin-top: 24px;\n  box-shadow: 0 4px 16px rgba(255, 111, 97, 0.3);\n}\n\n.wizard-add-person-page .fiscal-parts-display .label {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 17px;\n  font-weight: 500;\n}\n\n.wizard-add-person-page .fiscal-parts-display .parts {\n  color: white;\n  font-size: 32px;\n  font-weight: 700;\n}\n\n/* Employment cards */\n.wizard-add-person-page .employment-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 14px;\n}\n\n.wizard-add-person-page .employment-card {\n  padding: 20px 16px;\n  border: 2px solid #E2E8F0;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background: white;\n  position: relative;\n}\n\n.wizard-add-person-page .employment-card:hover {\n  border-color: #3B82F6;\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n.wizard-add-person-page .employment-card.selected {\n  border-color: #3B82F6;\n  background: linear-gradient(180deg, #EFF6FF 0%, white 100%);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n\n.wizard-add-person-page .employment-icon {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n\n.wizard-add-person-page .employment-label {\n  font-weight: 600;\n  color: #334155;\n  font-size: 15px;\n}\n\n.wizard-add-person-page .employment-card .check-mark {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 24px;\n  height: 24px;\n  background: #3B82F6;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.wizard-add-person-page .hint-inline {\n  font-size: 13px;\n  font-weight: 400;\n  color: #94A3B8;\n  margin-left: 10px;\n}\n\n/* ===================== FULL PAGE STEP 2: INCOMES ===================== */\n\n.wizard-add-person-page .income-sources-header {\n  margin-bottom: 28px;\n}\n\n.wizard-add-person-page .income-sources-header h4 {\n  margin: 0 0 10px 0;\n  font-size: 20px;\n  color: #1E293B;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.wizard-add-person-page .income-sources-header .hint {\n  color: #64748B;\n  font-size: 15px;\n  margin: 0;\n}\n\n.wizard-add-person-page .income-category {\n  margin-bottom: 24px;\n  background: #F8FAFC;\n  border-radius: 14px;\n  padding: 20px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-person-page .category-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.wizard-add-person-page .category-label {\n  font-weight: 600;\n  font-size: 15px;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.wizard-add-person-page .category-add-buttons {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-person-page .add-type-btn {\n  padding: 10px 16px;\n  border: 2px solid #CBD5E1;\n  background: white;\n  border-radius: 10px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-add-person-page .add-type-btn:hover {\n  border-color: #3B82F6;\n  background: #EFF6FF;\n  color: #3B82F6;\n}\n\n.wizard-add-person-page .add-type-btn .btn-icon {\n  width: 28px;\n  height: 28px;\n  background: #E2E8F0;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: #475569;\n}\n\n.wizard-add-person-page .add-type-btn:hover .btn-icon {\n  background: #3B82F6;\n  color: white;\n}\n\n.wizard-add-person-page .add-type-btn .btn-label {\n  font-weight: 500;\n}\n\n.wizard-add-person-page .category-sources {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.wizard-add-person-page .income-source-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 18px;\n  background: white;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  transition: box-shadow 0.2s;\n  flex-wrap: wrap;\n}\n\n.wizard-add-person-page .income-source-row:hover {\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.wizard-add-person-page .income-source-row .source-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: white;\n  flex-shrink: 0;\n}\n\n.wizard-add-person-page .income-source-row .source-type {\n  font-weight: 600;\n  font-size: 15px;\n  color: #334155;\n  min-width: 120px;\n}\n\n.wizard-add-person-page .income-source-row .source-label {\n  flex: 1;\n  padding: 10px 14px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 14px;\n  min-width: 140px;\n}\n\n.wizard-add-person-page .income-source-row .source-label:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person-page .income-source-row .source-period-label {\n  font-size: 13px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-person-page .income-source-row .source-date {\n  padding: 10px 14px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 14px;\n  width: 150px;\n}\n\n.wizard-add-person-page .income-source-row .source-date:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person-page .remove-source-btn {\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  opacity: 0.4;\n  transition: all 0.2s;\n  color: #64748B;\n}\n\n.wizard-add-person-page .remove-source-btn:hover {\n  opacity: 1;\n  background: #FEE2E2;\n  color: #DC2626;\n}\n\n.wizard-add-person-page .no-sources-hint {\n  text-align: center;\n  padding: 48px 24px;\n  color: #64748B;\n}\n\n.wizard-add-person-page .no-sources-hint p {\n  margin: 0;\n  font-size: 15px;\n}\n\n.wizard-add-person-page .generate-tables-section {\n  margin-top: 32px;\n  text-align: center;\n}\n\n.wizard-add-person-page .generate-btn {\n  padding: 18px 40px;\n  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);\n  color: white;\n  border: none;\n  border-radius: 14px;\n  font-size: 17px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);\n}\n\n.wizard-add-person-page .generate-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(59, 130, 246, 0.4);\n}\n\n/* Year tabs sub-step - Full Page */\n.wizard-add-person-page .income-years-header {\n  margin-bottom: 20px;\n}\n\n.wizard-add-person-page .back-to-sources-btn {\n  padding: 12px 18px;\n  background: #F1F5F9;\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person-page .back-to-sources-btn:hover {\n  background: #E2E8F0;\n  color: #475569;\n}\n\n.wizard-add-person-page .year-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 24px;\n  padding: 14px;\n  background: #F1F5F9;\n  border-radius: 14px;\n  overflow-x: auto;\n}\n\n.wizard-add-person-page .year-tab {\n  padding: 14px 28px;\n  background: white;\n  border: 2px solid #E2E8F0;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.wizard-add-person-page .year-tab:hover {\n  border-color: #3B82F6;\n  color: #3B82F6;\n}\n\n.wizard-add-person-page .year-tab.active {\n  background: #3B82F6;\n  border-color: #3B82F6;\n  color: white;\n  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);\n}\n\n.wizard-add-person-page .year-table-container {\n  background: white;\n  border: 2px solid #E2E8F0;\n  border-radius: 14px;\n  padding: 24px;\n}\n\n.wizard-add-person-page .year-table-container h4 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  color: #1E293B;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.wizard-add-person-page .year-income-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 15px;\n}\n\n.wizard-add-person-page .year-income-table thead {\n  background: #F8FAFC;\n}\n\n.wizard-add-person-page .year-income-table th {\n  padding: 14px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #64748B;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #E2E8F0;\n}\n\n.wizard-add-person-page .year-income-table td {\n  padding: 14px 12px;\n  border-bottom: 1px solid #F1F5F9;\n  vertical-align: middle;\n}\n\n.wizard-add-person-page .year-income-table .col-type {\n  min-width: 180px;\n}\n\n.wizard-add-person-page .year-income-table .type-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  color: white;\n  font-weight: 700;\n  font-size: 11px;\n  margin-right: 10px;\n}\n\n.wizard-add-person-page .year-income-table .type-label {\n  font-weight: 500;\n  color: #334155;\n}\n\n.wizard-add-person-page .year-income-table .source-label-small {\n  display: block;\n  font-size: 12px;\n  color: #64748B;\n  margin-top: 4px;\n  font-weight: 400;\n  margin-left: 46px;\n}\n\n.wizard-add-person-page .year-income-table .col-date {\n  font-size: 14px;\n  color: #64748B;\n  text-align: center;\n  min-width: 70px;\n}\n\n.wizard-add-person-page .year-income-table .col-amount {\n  min-width: 140px;\n}\n\n.wizard-add-person-page .year-income-table .col-amount input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 10px;\n  font-size: 15px;\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.wizard-add-person-page .year-income-table .col-amount input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person-page .year-income-table .col-charges {\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n  color: #EF4444;\n  min-width: 110px;\n}\n\n.wizard-add-person-page .year-income-table .col-taxable {\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n  color: #10B981;\n  font-weight: 600;\n  min-width: 110px;\n}\n\n.wizard-add-person-page .year-income-table .col-detail {\n  text-align: center;\n  width: 60px;\n}\n\n.wizard-add-person-page .detail-btn {\n  background: #F1F5F9;\n  border: 1px solid #E2E8F0;\n  font-size: 18px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: #64748B;\n}\n\n.wizard-add-person-page .detail-btn:hover {\n  background: #3B82F6;\n  color: white;\n  border-color: #3B82F6;\n}\n\n.wizard-add-person-page .year-income-table tfoot {\n  background: linear-gradient(180deg, #F8FAFC 0%, #EFF6FF 100%);\n}\n\n.wizard-add-person-page .year-income-table .totals-row td {\n  padding: 18px 12px;\n  border-bottom: none;\n  border-top: 2px solid #E2E8F0;\n}\n\n.wizard-add-person-page .year-income-table .totals-row .col-taxable {\n  color: #059669;\n}\n\n/* Summary step - Simplified DansMaPoche view */\n.wizard-add-person-page .summary-step {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Person header */\n.wizard-add-person-page .summary-person-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 20px;\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-person-page .summary-person-header .person-name {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1E293B;\n}\n\n.wizard-add-person-page .summary-person-header .person-info {\n  font-size: 14px;\n  color: #64748B;\n  margin-top: 4px;\n}\n\n.wizard-add-person-page .summary-person-header .sources-count {\n  font-size: 13px;\n  color: #94A3B8;\n  margin-top: 8px;\n  padding: 4px 12px;\n  background: #F1F5F9;\n  border-radius: 20px;\n}\n\n/* DansMaPoche year cards */\n.wizard-add-person-page .dansmapoche-years {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.wizard-add-person-page .dansmapoche-year-card {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #E2E8F0;\n  overflow: hidden;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .year-label {\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #334155 0%, #1E293B 100%);\n  color: white;\n  font-size: 18px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .year-breakdown {\n  padding: 16px 20px;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .breakdown-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .breakdown-row:last-child {\n  border-bottom: none;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .row-label {\n  font-size: 14px;\n  color: #64748B;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .row-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .row-value.negative {\n  color: #DC2626;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .row-value.highlight {\n  font-size: 20px;\n  font-weight: 700;\n  color: #059669;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .dansmapoche-row {\n  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);\n  margin: 0 -20px;\n  padding: 12px 20px;\n  border-bottom: none;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .dansmapoche-row .row-label {\n  font-weight: 600;\n  color: #047857;\n}\n\n.wizard-add-person-page .dansmapoche-year-card .monthly-equivalent {\n  padding: 10px 20px;\n  background: #F8FAFC;\n  text-align: center;\n  font-size: 13px;\n  color: #64748B;\n}\n\n/* No data message */\n.wizard-add-person-page .no-data-message {\n  text-align: center;\n  padding: 40px 20px;\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-person-page .no-data-message p {\n  margin: 8px 0;\n  color: #64748B;\n}\n\n/* Disclaimer */\n.wizard-add-person-page .summary-disclaimer {\n  padding: 12px 16px;\n  background: #FFFBEB;\n  border-radius: 10px;\n  border-left: 4px solid #F59E0B;\n  font-size: 13px;\n  color: #92400E;\n  text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .wizard-add-person-page .dansmapoche-years {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Detail Modal - Full Page version */\n.detail-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.detail-modal {\n  background: white;\n  border-radius: 18px;\n  width: 480px;\n  max-width: 90vw;\n  max-height: 80vh;\n  overflow: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n}\n\n.detail-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 28px;\n  border-bottom: 1px solid #E2E8F0;\n  position: sticky;\n  top: 0;\n  background: white;\n}\n\n.detail-modal-header h4 {\n  margin: 0;\n  font-size: 20px;\n  color: #1E293B;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.detail-modal-header .modal-badge {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: white;\n}\n\n.detail-modal-header button {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #94A3B8;\n  cursor: pointer;\n  padding: 4px;\n  transition: color 0.2s;\n  line-height: 1;\n}\n\n.detail-modal-header button:hover {\n  color: #475569;\n}\n\n.detail-modal-body {\n  padding: 28px;\n}\n\n.detail-modal-body .form-group {\n  margin-bottom: 20px;\n}\n\n.detail-modal-body .form-group label {\n  display: block;\n  font-size: 15px;\n  font-weight: 500;\n  color: #475569;\n  margin-bottom: 10px;\n}\n\n.detail-modal-body .form-group input[type=\"text\"],\n.detail-modal-body .form-group input[type=\"number\"] {\n  width: 100%;\n  padding: 14px 16px;\n  border: 2px solid #E2E8F0;\n  border-radius: 10px;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.detail-modal-body .form-group input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.detail-modal-body .field-hint {\n  font-size: 13px;\n  color: #64748B;\n  margin-top: 8px;\n}\n\n.detail-modal-body .checkbox-group {\n  margin-top: 16px;\n}\n\n.detail-modal-body .checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding: 14px 18px;\n  background: #F8FAFC;\n  border-radius: 10px;\n  border: 1px solid #E2E8F0;\n  font-size: 14px;\n}\n\n.detail-modal-body .checkbox-label input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #3B82F6;\n}\n\n.detail-hint {\n  font-size: 14px;\n  color: #64748B;\n  padding: 14px 16px;\n  background: #F8FAFC;\n  border-radius: 10px;\n  margin-top: 12px;\n  border: 1px solid #E2E8F0;\n}\n\n.detail-modal-footer {\n  padding: 20px 28px;\n  border-top: 1px solid #E2E8F0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.detail-modal-footer .close-modal-btn {\n  padding: 14px 28px;\n  background: #3B82F6;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.detail-modal-footer .close-modal-btn:hover {\n  background: #2563EB;\n}\n\n/* ===================== LEGACY MODAL STEPS ===================== */\n\n/* Steps indicator */\n.wizard-add-person .steps-indicator {\n  display: flex;\n  justify-content: center;\n  gap: 60px;\n  padding: 24px 32px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-person .step-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  opacity: 0.5;\n  transition: opacity 0.2s;\n}\n\n.wizard-add-person .step-indicator.active,\n.wizard-add-person .step-indicator.completed {\n  opacity: 1;\n}\n\n.wizard-add-person .step-indicator .step-number {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #E2E8F0;\n  color: #64748B;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 16px;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .step-indicator.active .step-number {\n  background: #FF6F61;\n  color: white;\n  box-shadow: 0 4px 12px rgba(255, 111, 97, 0.4);\n}\n\n.wizard-add-person .step-indicator.completed .step-number {\n  background: #10B981;\n  color: white;\n}\n\n.wizard-add-person .step-indicator .step-label {\n  font-size: 14px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-person .step-indicator.active .step-label {\n  color: #FF6F61;\n  font-weight: 600;\n}\n\n/* Body */\n.wizard-add-person .wizard-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 32px 48px;\n}\n\n.wizard-add-person .step-content {\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n/* Form sections */\n.wizard-add-person .form-section {\n  margin-bottom: 32px;\n}\n\n.wizard-add-person .form-section h4 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  color: #334155;\n  margin: 0 0 20px 0;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #E2E8F0;\n}\n\n.wizard-add-person .section-icon {\n  font-size: 22px;\n}\n\n/* Form elements */\n.wizard-add-person .form-row {\n  display: flex;\n  gap: 20px;\n}\n\n.wizard-add-person .form-row .form-group {\n  flex: 1;\n}\n\n.wizard-add-person .form-group {\n  margin-bottom: 20px;\n}\n\n.wizard-add-person .form-group label {\n  display: block;\n  font-size: 14px;\n  color: #475569;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.wizard-add-person .form-group input[type=\"text\"],\n.wizard-add-person .form-group input[type=\"number\"],\n.wizard-add-person .form-group select {\n  width: 100%;\n  padding: 14px 16px;\n  border: 2px solid #E2E8F0;\n  border-radius: 10px;\n  font-size: 16px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-sizing: border-box;\n}\n\n.wizard-add-person .form-group input:focus,\n.wizard-add-person .form-group select:focus {\n  outline: none;\n  border-color: #FF6F61;\n  box-shadow: 0 0 0 4px rgba(255, 111, 97, 0.1);\n}\n\n/* Status cards */\n.wizard-add-person .status-cards {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-person .status-card {\n  flex: 1;\n  min-width: 100px;\n  padding: 16px 12px;\n  border: 2px solid #E2E8F0;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background: white;\n}\n\n.wizard-add-person .status-card:hover {\n  border-color: #FF6F61;\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n.wizard-add-person .status-card.selected {\n  border-color: #FF6F61;\n  background: linear-gradient(180deg, #FFF5F4 0%, white 100%);\n  box-shadow: 0 0 0 4px rgba(255, 111, 97, 0.15);\n}\n\n.wizard-add-person .status-icon {\n  font-size: 28px;\n  margin-bottom: 8px;\n}\n\n.wizard-add-person .status-label {\n  font-weight: 600;\n  color: #334155;\n  font-size: 13px;\n}\n\n/* Children control */\n.wizard-add-person .children-control {\n  display: inline-flex;\n  align-items: center;\n  gap: 16px;\n  background: #F1F5F9;\n  padding: 12px 24px;\n  border-radius: 12px;\n}\n\n.wizard-add-person .children-btn {\n  width: 44px;\n  height: 44px;\n  border: 2px solid #CBD5E1;\n  background: white;\n  border-radius: 50%;\n  font-size: 24px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748B;\n}\n\n.wizard-add-person .children-btn:hover:not(:disabled) {\n  border-color: #FF6F61;\n  color: #FF6F61;\n}\n\n.wizard-add-person .children-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.wizard-add-person .children-btn.plus:hover:not(:disabled) {\n  background: #FF6F61;\n  border-color: #FF6F61;\n  color: white;\n}\n\n.wizard-add-person .children-count {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1E293B;\n  min-width: 50px;\n  text-align: center;\n}\n\n/* Checkbox */\n.wizard-add-person .checkbox-group {\n  margin-top: 16px;\n}\n\n.wizard-add-person .checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding: 14px 20px;\n  background: #FFF7F6;\n  border-radius: 10px;\n  border: 2px solid #FFE5E2;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .checkbox-label:hover {\n  background: #FFE5E2;\n}\n\n.wizard-add-person .checkbox-label input[type=\"checkbox\"] {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n  accent-color: #FF6F61;\n}\n\n/* Fiscal parts display */\n.wizard-add-person .fiscal-parts-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 28px;\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  border-radius: 14px;\n  margin-top: 20px;\n  box-shadow: 0 4px 16px rgba(255, 111, 97, 0.3);\n}\n\n.wizard-add-person .fiscal-parts-display .label {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.wizard-add-person .fiscal-parts-display .parts {\n  color: white;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n/* Employment cards */\n.wizard-add-person .employment-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 12px;\n}\n\n.wizard-add-person .employment-card {\n  padding: 18px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background: white;\n}\n\n.wizard-add-person .employment-card:hover {\n  border-color: #3B82F6;\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n.wizard-add-person .employment-card.selected {\n  border-color: #3B82F6;\n  background: linear-gradient(180deg, #EFF6FF 0%, white 100%);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n\n.wizard-add-person .employment-icon {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.wizard-add-person .employment-label {\n  font-weight: 600;\n  color: #334155;\n  font-size: 14px;\n}\n\n/* Multi-select employment cards */\n.wizard-add-person .employment-cards.multi-select .employment-card {\n  position: relative;\n}\n\n.wizard-add-person .employment-card .check-mark {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 22px;\n  height: 22px;\n  background: #3B82F6;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.wizard-add-person .hint-inline {\n  font-size: 12px;\n  font-weight: 400;\n  color: #94A3B8;\n  margin-left: 8px;\n}\n\n.wizard-add-person .selection-info {\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: #EFF6FF;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #3B82F6;\n  border: 1px solid #BFDBFE;\n}\n\n/* Auto-flow progress indicator in income editor */\n.wizard-add-person .income-editor h4 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 18px;\n  color: #1E293B;\n  margin: 0 0 20px 0;\n}\n\n.wizard-add-person .auto-flow-progress {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 20px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #F0FDF4 0%, #ECFDF5 100%);\n  border-radius: 10px;\n  border: 1px solid #BBF7D0;\n}\n\n.wizard-add-person .auto-flow-progress .progress-text {\n  font-size: 13px;\n  color: #166534;\n  font-weight: 500;\n}\n\n.wizard-add-person .auto-flow-progress .progress-dots {\n  display: flex;\n  gap: 6px;\n  margin-left: auto;\n}\n\n.wizard-add-person .auto-flow-progress .progress-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #D1FAE5;\n  border: 2px solid #10B981;\n}\n\n.wizard-add-person .auto-flow-progress .progress-dot.completed {\n  background: #10B981;\n}\n\n.wizard-add-person .auto-flow-progress .progress-dot.current {\n  background: #10B981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.3);\n}\n\n/* ===================== STEP 2: INCOMES - V2 DESIGN ===================== */\n\n/* Income sources header */\n.wizard-add-person .income-sources-header {\n  margin-bottom: 24px;\n}\n\n.wizard-add-person .income-sources-header h4 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  color: #1E293B;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.wizard-add-person .income-sources-header .hint {\n  color: #64748B;\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Income categories */\n.wizard-add-person .income-category {\n  margin-bottom: 20px;\n  background: #F8FAFC;\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-person .category-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.wizard-add-person .category-label {\n  font-weight: 600;\n  font-size: 14px;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.wizard-add-person .category-add-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.wizard-add-person .add-type-btn {\n  padding: 8px 14px;\n  border: 2px dashed #CBD5E1;\n  background: white;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-add-person .add-type-btn:hover {\n  border-color: #3B82F6;\n  border-style: solid;\n  background: #EFF6FF;\n  color: #3B82F6;\n}\n\n/* Category sources (income rows) */\n.wizard-add-person .category-sources {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wizard-add-person .income-source-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: white;\n  border-radius: 10px;\n  border: 1px solid #E2E8F0;\n  transition: box-shadow 0.2s;\n}\n\n.wizard-add-person .income-source-row:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.wizard-add-person .income-source-row .source-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: white;\n  flex-shrink: 0;\n}\n\n.wizard-add-person .income-source-row .source-type {\n  font-weight: 600;\n  font-size: 14px;\n  color: #334155;\n  min-width: 100px;\n}\n\n.wizard-add-person .income-source-row .source-label {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  min-width: 100px;\n}\n\n.wizard-add-person .income-source-row .source-label:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person .income-source-row .source-period-label {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.wizard-add-person .income-source-row .source-date {\n  padding: 8px 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 14px;\n  width: 140px;\n}\n\n.wizard-add-person .income-source-row .source-date:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person .remove-source-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  opacity: 0.5;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .remove-source-btn:hover {\n  opacity: 1;\n  background: #FEE2E2;\n}\n\n/* No sources hint */\n.wizard-add-person .no-sources-hint {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748B;\n}\n\n.wizard-add-person .no-sources-hint p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Generate tables button */\n.wizard-add-person .generate-tables-section {\n  margin-top: 24px;\n  text-align: center;\n}\n\n.wizard-add-person .generate-btn {\n  padding: 16px 32px;\n  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.wizard-add-person .generate-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n/* ===================== YEAR TABS SUB-STEP ===================== */\n\n.wizard-add-person .income-years-header {\n  margin-bottom: 16px;\n}\n\n.wizard-add-person .back-to-sources-btn {\n  padding: 10px 16px;\n  background: #F1F5F9;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .back-to-sources-btn:hover {\n  background: #E2E8F0;\n  color: #475569;\n}\n\n/* Year tabs */\n.wizard-add-person .year-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n  padding: 12px;\n  background: #F1F5F9;\n  border-radius: 12px;\n  overflow-x: auto;\n}\n\n.wizard-add-person .year-tab {\n  padding: 12px 24px;\n  background: white;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.wizard-add-person .year-tab:hover {\n  border-color: #3B82F6;\n  color: #3B82F6;\n}\n\n.wizard-add-person .year-tab.active {\n  background: #3B82F6;\n  border-color: #3B82F6;\n  color: white;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* Year table container */\n.wizard-add-person .year-table-container {\n  background: white;\n  border: 2px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.wizard-add-person .year-table-container h4 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  color: #1E293B;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n/* Year income table */\n.wizard-add-person .year-income-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.wizard-add-person .year-income-table thead {\n  background: #F8FAFC;\n}\n\n.wizard-add-person .year-income-table th {\n  padding: 12px 10px;\n  text-align: left;\n  font-weight: 600;\n  color: #64748B;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #E2E8F0;\n}\n\n.wizard-add-person .year-income-table td {\n  padding: 12px 10px;\n  border-bottom: 1px solid #F1F5F9;\n  vertical-align: middle;\n}\n\n.wizard-add-person .year-income-table .col-type {\n  min-width: 150px;\n}\n\n.wizard-add-person .year-income-table .type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  color: white;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.wizard-add-person .year-income-table .source-label-small {\n  display: block;\n  font-size: 11px;\n  color: #64748B;\n  margin-top: 4px;\n  font-weight: 400;\n}\n\n.wizard-add-person .year-income-table .col-date {\n  font-size: 13px;\n  color: #64748B;\n  text-align: center;\n  min-width: 60px;\n}\n\n.wizard-add-person .year-income-table .col-amount {\n  min-width: 120px;\n}\n\n.wizard-add-person .year-income-table .col-amount input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 14px;\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.wizard-add-person .year-income-table .col-amount input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person .year-income-table .col-charges {\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n  color: #EF4444;\n  min-width: 100px;\n}\n\n.wizard-add-person .year-income-table .col-taxable {\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n  color: #10B981;\n  font-weight: 600;\n  min-width: 100px;\n}\n\n.wizard-add-person .year-income-table .col-detail {\n  text-align: center;\n  width: 50px;\n}\n\n.wizard-add-person .detail-btn {\n  background: #F1F5F9;\n  border: 1px solid #E2E8F0;\n  font-size: 16px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .detail-btn:hover {\n  background: #E2E8F0;\n}\n\n/* Totals row */\n.wizard-add-person .year-income-table tfoot {\n  background: linear-gradient(180deg, #F8FAFC 0%, #EFF6FF 100%);\n}\n\n.wizard-add-person .year-income-table .totals-row td {\n  padding: 16px 10px;\n  border-bottom: none;\n  border-top: 2px solid #E2E8F0;\n}\n\n.wizard-add-person .year-income-table .totals-row .col-taxable {\n  color: #059669;\n}\n\n/* ===================== DETAIL MODAL ===================== */\n\n.wizard-add-person .detail-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.wizard-add-person .detail-modal {\n  background: white;\n  border-radius: 16px;\n  width: 400px;\n  max-width: 90vw;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.wizard-add-person .detail-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.wizard-add-person .detail-modal-header h4 {\n  margin: 0;\n  font-size: 18px;\n  color: #1E293B;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.wizard-add-person .detail-modal-header button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #94A3B8;\n  cursor: pointer;\n  padding: 4px;\n  transition: color 0.2s;\n}\n\n.wizard-add-person .detail-modal-header button:hover {\n  color: #475569;\n}\n\n.wizard-add-person .detail-modal-body {\n  padding: 24px;\n}\n\n.wizard-add-person .detail-modal-body .form-group {\n  margin-bottom: 16px;\n}\n\n.wizard-add-person .detail-modal-body .form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #475569;\n  margin-bottom: 8px;\n}\n\n.wizard-add-person .detail-modal-body .form-group input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 15px;\n  box-sizing: border-box;\n}\n\n.wizard-add-person .detail-modal-body .form-group input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person .detail-hint {\n  font-size: 13px;\n  color: #64748B;\n  padding: 12px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  margin-top: 8px;\n}\n\n.wizard-add-person .detail-modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #E2E8F0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.wizard-add-person .detail-modal-footer button {\n  padding: 12px 24px;\n  background: #3B82F6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.wizard-add-person .detail-modal-footer button:hover {\n  background: #2563EB;\n}\n\n/* Summary income label */\n.wizard-add-person .summary-income .income-label {\n  font-size: 13px;\n  color: #64748B;\n  font-style: italic;\n}\n\n/* ===================== OLD STEP 2 STYLES (kept for compatibility) ===================== */\n\n/* Income type cards */\n.wizard-add-person .income-type-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.wizard-add-person .income-type-card {\n  padding: 16px 12px;\n  border: 2px solid #E2E8F0;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  background: white;\n}\n\n.wizard-add-person .income-type-card:hover {\n  border-color: var(--card-color, #3B82F6);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.wizard-add-person .income-type-card.selected {\n  border-color: var(--card-color, #3B82F6);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n\n.wizard-add-person .income-type-card .type-icon {\n  font-size: 28px;\n  margin-bottom: 6px;\n}\n\n.wizard-add-person .income-type-card .type-label {\n  font-weight: 600;\n  color: #334155;\n  font-size: 13px;\n}\n\n/* Specific fields */\n.wizard-add-person .specific-fields {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.wizard-add-person .specific-field {\n  flex: 1;\n}\n\n.wizard-add-person .specific-field select {\n  width: 100%;\n  padding: 12px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n/* Year selector */\n.wizard-add-person .year-selector {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px;\n  background: #F1F5F9;\n  border-radius: 12px;\n  margin-bottom: 16px;\n}\n\n.wizard-add-person .year-chip {\n  position: relative;\n  padding: 10px 16px;\n  border: 2px solid #E2E8F0;\n  background: white;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .year-chip:hover {\n  border-color: #94A3B8;\n  color: #334155;\n}\n\n.wizard-add-person .year-chip.selected {\n  border-color: #3B82F6;\n  background: #3B82F6;\n  color: white;\n}\n\n.wizard-add-person .year-chip.current {\n  border-color: #10B981;\n}\n\n.wizard-add-person .year-chip.current.selected {\n  background: #10B981;\n  border-color: #10B981;\n}\n\n.wizard-add-person .year-chip .current-badge {\n  position: absolute;\n  top: -8px;\n  right: -4px;\n  font-size: 9px;\n  background: #10B981;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.wizard-add-person .year-chip.selected .current-badge {\n  background: white;\n  color: #10B981;\n}\n\n/* Yearly amounts grid */\n.wizard-add-person .yearly-amounts-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: #F8FAFC;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.wizard-add-person .year-amount-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.wizard-add-person .year-label {\n  font-weight: 600;\n  color: #475569;\n  min-width: 50px;\n  font-size: 15px;\n}\n\n.wizard-add-person .year-amount-row input {\n  flex: 0 0 160px;\n  padding: 12px 14px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 15px;\n}\n\n.wizard-add-person .year-amount-row input:focus {\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person .taxable-preview {\n  font-size: 13px;\n  color: #10B981;\n  font-weight: 500;\n}\n\n/* Income editor actions */\n.wizard-add-person .income-editor-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #E2E8F0;\n}\n\n/* ===================== INCOMES TABLE ===================== */\n\n.wizard-add-person .incomes-table-container {\n  margin-bottom: 24px;\n  border: 2px solid #E2E8F0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.wizard-add-person .incomes-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.wizard-add-person .incomes-table thead {\n  background: #F1F5F9;\n}\n\n.wizard-add-person .incomes-table th {\n  padding: 14px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #475569;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #E2E8F0;\n}\n\n.wizard-add-person .incomes-table td {\n  padding: 14px 12px;\n  border-bottom: 1px solid #F1F5F9;\n  color: #334155;\n}\n\n.wizard-add-person .incomes-table .income-row {\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.wizard-add-person .incomes-table .income-row:hover {\n  background: #F8FAFC;\n}\n\n.wizard-add-person .incomes-table .col-type {\n  width: 160px;\n}\n\n.wizard-add-person .incomes-table .col-period {\n  width: 100px;\n  text-align: center;\n}\n\n.wizard-add-person .incomes-table .col-gross,\n.wizard-add-person .incomes-table .col-charges,\n.wizard-add-person .incomes-table .col-taxable {\n  width: 100px;\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.wizard-add-person .incomes-table .col-taxable {\n  color: #10B981;\n  font-weight: 600;\n}\n\n.wizard-add-person .incomes-table .col-actions {\n  width: 50px;\n  text-align: center;\n}\n\n.wizard-add-person .incomes-table .type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  color: white;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.wizard-add-person .incomes-table .action-btn {\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  transition: background 0.2s;\n  opacity: 0.5;\n}\n\n.wizard-add-person .incomes-table .income-row:hover .action-btn {\n  opacity: 1;\n}\n\n.wizard-add-person .incomes-table .action-btn:hover {\n  background: #FEE2E2;\n}\n\n.wizard-add-person .incomes-table tfoot {\n  background: linear-gradient(180deg, #F8FAFC 0%, #EFF6FF 100%);\n}\n\n.wizard-add-person .incomes-table .totals-row td {\n  padding: 16px 12px;\n  border-bottom: none;\n  border-top: 2px solid #E2E8F0;\n}\n\n.wizard-add-person .incomes-table .totals-row .col-taxable {\n  color: #059669;\n}\n\n/* ===================== YEARLY AMOUNTS TABLE (Editor) ===================== */\n\n.wizard-add-person .yearly-amounts-table {\n  background: #F8FAFC;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n}\n\n.wizard-add-person .yearly-amounts-header {\n  display: flex;\n  align-items: center;\n  padding: 8px 0 12px 0;\n  margin-bottom: 8px;\n  border-bottom: 2px solid #E2E8F0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.wizard-add-person .yearly-amounts-header .col-year {\n  width: 60px;\n}\n\n.wizard-add-person .yearly-amounts-header .col-amount {\n  flex: 1;\n  text-align: center;\n}\n\n.wizard-add-person .yearly-amounts-header .col-charges {\n  flex: 1;\n  text-align: center;\n}\n\n.wizard-add-person .yearly-amounts-header .col-taxable {\n  width: 100px;\n  text-align: right;\n}\n\n.wizard-add-person .year-amount-row {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n}\n\n.wizard-add-person .year-amount-row .col-year {\n  width: 60px;\n  font-weight: 600;\n  color: #475569;\n  font-size: 15px;\n}\n\n.wizard-add-person .year-amount-row .col-amount,\n.wizard-add-person .year-amount-row .col-charges {\n  flex: 1;\n  padding: 0 8px;\n}\n\n.wizard-add-person .year-amount-row .col-amount input,\n.wizard-add-person .year-amount-row .col-charges input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 14px;\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.wizard-add-person .year-amount-row .col-amount input:focus,\n.wizard-add-person .year-amount-row .col-charges input:focus {\n  border-color: #3B82F6;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.wizard-add-person .year-amount-row .col-taxable {\n  width: 100px;\n  text-align: right;\n  color: #10B981;\n  font-weight: 600;\n  font-size: 14px;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.wizard-add-person .charges-hint {\n  margin-top: 12px;\n  padding: 10px 14px;\n  background: #FEF3C7;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #92400E;\n  border: 1px solid #FCD34D;\n}\n\n/* Add income button */\n.wizard-add-person .add-income-btn {\n  width: 100%;\n  padding: 20px;\n  border: 3px dashed #CBD5E1;\n  background: #F8FAFC;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .add-income-btn:hover {\n  border-color: #3B82F6;\n  color: #3B82F6;\n  background: #EFF6FF;\n}\n\n/* No incomes hint */\n.wizard-add-person .no-incomes-hint {\n  text-align: center;\n  padding: 32px;\n  color: #64748B;\n}\n\n.wizard-add-person .no-incomes-hint p {\n  margin: 0 0 8px 0;\n}\n\n.wizard-add-person .no-incomes-hint .hint {\n  font-size: 13px;\n  color: #94A3B8;\n}\n\n/* ===================== STEP 3: SUMMARY ===================== */\n\n.wizard-add-person .summary-step {\n  padding: 0;\n}\n\n.wizard-add-person .summary-section {\n  background: white;\n  border: 2px solid #E2E8F0;\n  border-radius: 14px;\n  padding: 24px;\n  margin-bottom: 20px;\n}\n\n.wizard-add-person .summary-section h4 {\n  margin: 0 0 20px 0;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.wizard-add-person .summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.wizard-add-person .summary-row:last-child {\n  border-bottom: none;\n}\n\n.wizard-add-person .summary-row.highlight {\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  margin: 16px -24px -24px -24px;\n  padding: 16px 24px;\n  border-radius: 0 0 12px 12px;\n}\n\n.wizard-add-person .summary-row.highlight .summary-label,\n.wizard-add-person .summary-row.highlight .summary-value {\n  color: white;\n}\n\n.wizard-add-person .summary-label {\n  color: #64748B;\n  font-size: 14px;\n}\n\n.wizard-add-person .summary-value {\n  color: #1E293B;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.wizard-add-person .summary-income {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n}\n\n.wizard-add-person .summary-income .income-icon {\n  font-size: 24px;\n}\n\n.wizard-add-person .summary-income .income-type {\n  font-weight: 500;\n  color: #334155;\n}\n\n.wizard-add-person .summary-totals {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 2px solid #E2E8F0;\n}\n\n.wizard-add-person .summary-totals h5 {\n  margin: 0 0 16px 0;\n  font-size: 14px;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.wizard-add-person .summary-year-row {\n  display: flex;\n  gap: 20px;\n  padding: 10px 0;\n  font-size: 14px;\n}\n\n.wizard-add-person .summary-year-row .year {\n  font-weight: 600;\n  color: #1E293B;\n  min-width: 50px;\n}\n\n.wizard-add-person .summary-year-row .gross {\n  color: #64748B;\n}\n\n.wizard-add-person .summary-year-row .taxable {\n  color: #10B981;\n  font-weight: 600;\n}\n\n.wizard-add-person .no-data {\n  color: #94A3B8;\n  font-style: italic;\n}\n\n/* ===================== FOOTER ===================== */\n\n.wizard-add-person .wizard-footer {\n  display: flex;\n  align-items: center;\n  padding: 20px 32px;\n  border-top: 2px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.wizard-add-person .footer-spacer {\n  flex: 1;\n}\n\n.wizard-add-person .back-btn {\n  padding: 14px 28px;\n  border: 2px solid #CBD5E1;\n  background: white;\n  color: #64748B;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .back-btn:hover {\n  border-color: #94A3B8;\n  color: #475569;\n}\n\n.wizard-add-person .next-btn,\n.wizard-add-person .submit-btn {\n  padding: 14px 32px;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-add-person .next-btn {\n  background: #3B82F6;\n  color: white;\n}\n\n.wizard-add-person .next-btn:hover:not(:disabled) {\n  background: #2563EB;\n}\n\n.wizard-add-person .next-btn:disabled {\n  background: #CBD5E1;\n  cursor: not-allowed;\n}\n\n.wizard-add-person .submit-btn {\n  background: linear-gradient(135deg, #10B981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.wizard-add-person .submit-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\n}\n\n/* Buttons in income editor */\n.wizard-add-person .income-editor .cancel-btn {\n  padding: 12px 24px;\n  border: 2px solid #CBD5E1;\n  background: white;\n  color: #64748B;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.wizard-add-person .income-editor .save-btn {\n  padding: 12px 24px;\n  border: none;\n  background: #3B82F6;\n  color: white;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.wizard-add-person .income-editor .save-btn:disabled {\n  background: #CBD5E1;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 800px) {\n  .modal-content.wizard-add-person {\n    width: 100%;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .wizard-add-person .wizard-body {\n    padding: 24px;\n  }\n\n  .wizard-add-person .steps-indicator {\n    gap: 24px;\n    padding: 16px;\n  }\n\n  .wizard-add-person .status-cards {\n    flex-wrap: wrap;\n  }\n\n  .wizard-add-person .status-card {\n    flex: 0 0 calc(50% - 6px);\n  }\n\n  .wizard-add-person .year-amount-row {\n    flex-wrap: wrap;\n  }\n\n  .wizard-add-person .year-amount-row input {\n    flex: 1;\n    min-width: 120px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
